export const team_logos = [
  '-273',
  '-600',
  '-72c',
  '-97f',
  '-axecty',
  '-duckx',
  '-e',
  '-high5',
  '-illhouse',
  '-konoha-',
  '-lgod-efterskole',
  '-midnight-',
  '-n4shdv0r',
  '-org-',
  '-paralympics-',
  '-quick-hands-',
  '-redliners',
  '-rushingbsite-',
  '-skinvault',
  '-the-binmen-',
  '-xsv-clan-',
  '00-nation-prospects',
  '00-nation-talent',
  '00-nation',
  '00-prospects',
  '00-talent',
  '00nation-talent',
  '00nation',
  '00prospects',
  '01',
  '05-b4zuk4',
  '0chance-',
  '0rgl3s5',
  '10-yrs-of-main',
  '100-thieves',
  '1001-fragrance',
  '100monawek',
  '100pg',
  '100pinggods',
  '100ra',
  '1017-y-9es',
  '10avg',
  '11hoods',
  '13-avg',
  '1337',
  '1337uania',
  '15averagegang',
  '16-aces',
  '1620-kings',
  '17-mph',
  '1800-gang',
  '1984coffee',
  '1asteven-seagal',
  '1boomer4zoomer',
  '1dayheroes',
  '1diotteam',
  '1for1',
  '1gang',
  '1h-gaming',
  '1hp-gg',
  '1hp',
  '1nt',
  '1oavg',
  '1shot',
  '1tin',
  '1wesuck1',
  '1win-academy',
  '1win',
  '1wof6',
  '2-6-hog-cycle',
  '2-raw',
  '2077esports',
  '23club',
  '24bhb',
  '2990-esports',
  '2c-gavity',
  '2d2-team',
  '2ez',
  '2game',
  '2gi3ldon',
  '2h4u',
  '2kazoo2krewzoo2',
  '2kill-gaming',
  '2krovno',
  '2ndratetalent',
  '2space',
  '2vinesardine',
  '2zoomer3boomer',
  '3-feet-of-meat',
  '300iqstack',
  '30kstatus',
  '30yo-talents',
  '32',
  '335cg-m88',
  '39-bmi-warriors',
  '3decadas',
  '3dmax-aca',
  '3dmax',
  '3k-esport',
  '3k-raiderio',
  '3k',
  '3leggedfreaks',
  '3nation',
  '3plus2',
  '3sup-enterprises',
  '4-aguzka-u-shef',
  '40yearoldpeek',
  '45-mins',
  '4botsplusrelic',
  '4dk',
  '4elements',
  '4glory',
  '4kings',
  '4ormula',
  '4us',
  '4wb',
  '4ztankuamiley',
  '5-big-booms',
  '5-bots',
  '5-goblinz',
  '5-guys',
  '5-in-pit',
  '5-randoms',
  '500-rush',
  '500',
  '500esports',
  '500kgclub',
  '500x',
  '501st',
  '55th-st-crippin',
  '5balls',
  '5demon',
  '5doigts',
  '5fellas',
  '5frag-gaming',
  '5fyctimz',
  '5goblinz',
  '5hp',
  '5iveonit',
  '5k-academy',
  '5m-esports',
  '5manrush',
  '5mid',
  '5pellmans',
  '5power-gaming',
  '5power',
  '5randoms',
  '5star',
  '5tarz',
  '5warikov',
  '5x404',
  '6-foot-in-airforces',
  '6479',
  '666',
  '6666',
  '69',
  '6f-esports',
  '6o8',
  '6sense',
  '7-deadly-zyns',
  '7-heaven',
  '716-bangerz',
  '731',
  '773revival',
  '777-esport',
  '777',
  '7am',
  '7dsins',
  '7x',
  '88-bobsled',
  '886',
  '8ballers',
  '8ight',
  '8morts-6blesses',
  '8sins',
  '9-lives',
  '9-pandas-esports',
  '9-pandas',
  '91ashliu',
  '925-club',
  '95-vikings',
  '95vikings',
  '96-bulls',
  '99-percent',
  '99',
  '99dmgban',
  '99firepower-1utility-mix',
  '9ine-academy',
  '9ine',
  '9pandasfearless',
  '9z-academy',
  '9z-t-asia',
  '9z-team',
  '9z',
  'a-great-chaos',
  'a-losers',
  'a27',
  'aaa',
  'aab-eclipse',
  'aab-elite',
  'aab-esport',
  'aab-female',
  'aab',
  'aalborg-rebels',
  'aao',
  'ab',
  'abc4',
  'abcd',
  'abg-hunters',
  'ablaze-team',
  'able-esports',
  'abominapple',
  'above-team',
  'absent-minded',
  'absolute-cinema',
  'absolute-legends',
  'abt',
  'abuelos-locos',
  'abusement-park',
  'abyss',
  'abyssal',
  'academy-4-gifted-children',
  'academy-of-esports',
  'accelerate',
  'accusata',
  'ace-gaming',
  'acend',
  'acerbus',
  'aces',
  'achievo-esports',
  'ackbars5',
  'acl-esports',
  'acrux',
  'actic-esports',
  'activated',
  'activit-e-csgo',
  'activit-e',
  'ad-hoc',
  'adactiveg',
  'adagio',
  'adaptation',
  'addicted-esport',
  'adepts',
  'adive',
  'admiralsgg',
  'adn',
  'adnzpeek',
  'adult-swim',
  'adv-cs',
  'advance-esports',
  'advanced-pause',
  'adventurers',
  'aelg',
  'aequus-club',
  'aereq-one',
  'aero',
  'aers-money-crew',
  'aeternum',
  'aether',
  'aetheris',
  'aethers-guard',
  'aex-1',
  'affirmative',
  'afk-master',
  'afking',
  'africa',
  'after-hours',
  'after-peak',
  'after',
  'afu',
  'against-all-authority',
  'age-academy',
  'age-sports',
  'agency-clan',
  'agency-dojo',
  'agency-of-violence',
  'agency',
  'agenty',
  'agf-academy',
  'agf',
  'aggresive-hypep',
  'agns-frag-cafe',
  'ago-esports',
  'ago-gaming',
  'ago',
  'ah-mirrored',
  'ah-nightwatch',
  'ahjo',
  'ahtohallan',
  'aim-high',
  'aim2main',
  'aimassassins',
  'aimclub',
  'aimhaus',
  'aimoggers',
  'airborne',
  'airjordanz',
  'airlya',
  'ajax-esports',
  'ajf-e-sports',
  'ajf',
  'ajuri',
  'aka-hero-int',
  'aka-hero-kajo',
  'aka-hero',
  'akatsuki',
  'akave',
  'akimbo-esports',
  'akimbo',
  'akopalipsa',
  'al-ahli-esports',
  'alaska',
  'albanianboyzinc',
  'albin-the-gang',
  'algo',
  'algorithm-16',
  'aligon',
  'alka',
  'alke',
  'all-elementz',
  'all-gamers',
  'all-gas-no-brakes',
  'all-in',
  'alleyeson',
  'alliance-ac',
  'alliance',
  'allinners',
  'allstars-',
  'allstars',
  'allstarsacademy',
  'alltech-esports',
  'alma',
  'alpha-gaming',
  'alpha-red',
  'alpha-united',
  'alpha',
  'alsen-team',
  'also',
  'altay-espor',
  'altay',
  'alter-ego-academy',
  'alter-ego',
  'alter-iron-club',
  'alter-iron',
  'altered-edge',
  'alternate-attax',
  'alternative-flow',
  'altiora-esports',
  'altyra',
  'alumni',
  'alums-cabaret',
  'always-365',
  'am',
  'amazing-gaming',
  'ambidex',
  'ambush-e-sport',
  'ambush-esport',
  'ambush-fe',
  'ambush',
  'ameme',
  'amigosi',
  'amkal',
  'aml',
  'amnesia',
  'amo-esport',
  'amo-esports',
  'amo',
  'amoebits',
  'amog',
  'amped-esports',
  'amped-red',
  'amped',
  'amphis-gaming',
  'amplicity',
  'amsterdam-kings',
  'anatolian-foxes',
  'ancient-evil',
  'ancient-globals',
  'ancient',
  'andrew-piano-man-aclegi',
  'andromeda',
  'andromedagaming',
  'anecdote',
  'anexis-esports',
  'angelic-gaming',
  'animal-squad',
  'anime-avatars',
  'animosity',
  'animus-victoria',
  'anita-max-wynn',
  'ankaramessi',
  'anlaki',
  'annex',
  'annexesports',
  'anonymo-academy',
  'anonymo',
  'anorthosis-famagusta',
  'another-victim',
  'anox',
  'anteiku',
  'anti-eco-club',
  'antic',
  'antigrind',
  'antimaslo',
  'antwerpaces',
  'any-baggers',
  'anyonewantbud',
  'anything-else',
  'aogiri',
  'aokigahara',
  'aomaesports',
  'aorus-vision',
  'aox',
  'aparino-esports',
  'apek',
  'apeks-rebels',
  'apeks',
  'aperture-gaming',
  'apes',
  'apocalypse',
  'apocalypsedudes',
  'apogee',
  'apologis-esport',
  'apologis',
  'aporia',
  'applebees',
  'apx-energy',
  'aqp',
  'aqua-gaming',
  'aquila',
  'arabics',
  'aravt',
  'arc-dynasty',
  'arcade-academy',
  'arcade-esports',
  'arcade',
  'arcana',
  'arcane-wave',
  'arcane',
  'arch',
  'archangel5',
  'archangels',
  'arcred',
  'arctic-ratz',
  'arctic',
  'arcticexposure',
  'arcy',
  'are-you-kidding',
  'area-51-gaming',
  'area-gaming',
  'arena-bulls',
  'arena-jogue-facil',
  'ares-female',
  'argon',
  'argument-clinic',
  'arianas-kittens',
  'arise',
  'aristocracy',
  'arka-gdynia',
  'arkangel',
  'arktos-esports',
  'armann',
  'armitra-esports',
  'armitra-nxt',
  'armo',
  'armored-talent',
  'arpento',
  'arrached-v2000',
  'arrival-seven',
  'arrmy',
  'arrow-nxt',
  'arrow-reformed',
  'arrow',
  'arson1st',
  'art-of-cybergame',
  'artemis-esports',
  'artemis',
  'arthrose-peek',
  'artyk-gaming',
  'arvum',
  'asa',
  'asap',
  'ascend',
  'ascension',
  'ascent',
  'ase-pwr',
  'aseris',
  'asg',
  'asian-invasion',
  'asianstar',
  'ask',
  'asking-questions',
  'asoka',
  'asphalt-company',
  'asphalt',
  'aspyre',
  'assos-purple',
  'astana-dragons',
  'asterion-csgo',
  'asterion',
  'asterius-gaming',
  'asterys',
  'astony',
  'astral-aces',
  'astral-esports',
  'astral-influence',
  'astral',
  'astralis-',
  'astralis-talent',
  'astralis',
  'astramode',
  'astronavti',
  'astrum',
  'asuel',
  'asycs-kittens',
  'at-gaming',
  'ataks',
  'atb-gaming',
  'athena',
  'athletico-bh',
  'athletico-esports',
  'athletico',
  'athlon',
  'atk-academy',
  'atk-oshun',
  'atk',
  'atlando',
  'atlantic',
  'atlanticesports',
  'atlantis-esports',
  'atlantis',
  'atlas-esports',
  'atlas',
  'atmosferka',
  'atmosphere',
  'atom',
  'atomic-gaming',
  'atox',
  'atputies',
  'atrapa2',
  'atreides',
  'atrivm',
  'atrix',
  'attax-evo',
  'attitudecs',
  'attjunior',
  'auc-tigers',
  'audacity-prime',
  'audacity',
  'augaming',
  'august',
  'auntiecristie',
  'aura-uk',
  'aura',
  'aurofox',
  'auronix',
  'aurora-yb',
  'aurora-young-blood',
  'aurora-young-blud',
  'aurora',
  'australs',
  'austrian-force-willhaben',
  'austrian-force',
  'austrianforcew',
  'avalon',
  'avangar-1xbet',
  'avangar',
  'avant-gaming',
  'avant-garde',
  'avant',
  'avanti-main',
  'avanti',
  'avantiura',
  'avantura',
  'avasive-fe',
  'avasive',
  'ave',
  'aveon',
  'average-30yo',
  'avers',
  'avez-casters',
  'avez',
  'avocado-gelato',
  'avt',
  'awpenheimer',
  'awpnt',
  'awsomniac',
  'axies',
  'ayayayaya',
  'azio-esports',
  'azor',
  'azp-esport',
  'aztec-talent',
  'azuolas',
  'azym',
  'b-splehhh',
  'b',
  'b',
  'b',
  'b00mer5',
  'b00sted-bums',
  'b00sters',
  'b2tg-kingz',
  'b2tg',
  'b4-esports',
  'b4-fe',
  'b4',
  'b8-academy',
  'b8',
  'babag',
  'babos',
  'back-n-my-prime',
  'back2back',
  'backdoor-bandit',
  'backin1969',
  'backnforth',
  'backpacks-r-us',
  'backshot-gaming',
  'backshotbandits',
  'backwhenever',
  'bad-but-bored',
  'bad-esports',
  'bad-manners',
  'bad-news-balds',
  'bad-news-bears',
  'bad-news-bozos',
  'bad-news-eagles',
  'bad-news-emus',
  'bad-news-panthers',
  'badass',
  'badcompany',
  'bader-coiffeur',
  'badnewsbobers',
  'baecon-gaming-group',
  'baecon-gg',
  'baecon',
  'baecongg',
  'bag-talk',
  'bagel-boiis',
  'bailando',
  'bait-og-tilt',
  'baiters',
  'baiting-cucks',
  'baiting-noiro',
  'baitservice',
  'baja-blasters',
  'bajini-puleni',
  'baked-in-canada',
  'baks-esports',
  'baks',
  'balenciaga',
  'balkan-bears',
  'ballistic',
  'ballmer-peak',
  'balloon-animals',
  'balloonboysclub',
  'balls',
  'baltika',
  'bandits',
  'banger-gang',
  'bangers',
  'banging-moms',
  'bangoutoforder',
  'bangs',
  'banished-legion',
  'bankai',
  'bankapepsi',
  'banneret',
  'bantz',
  'bapticians',
  'bare-min-bandit',
  'barelymademain',
  'barelymain',
  'barry-pickers',
  'based',
  'basement-bobs',
  'basement-boys',
  'baskonia-esports',
  'bass-masters',
  'baubylos',
  'bazar-mix',
  'bbb',
  'bbbcbmbs',
  'bbl',
  'bbqrew',
  'bc-game',
  'bd',
  'bdr',
  'be-all-end-all',
  'be-five',
  'be-mix',
  'be-together-win',
  'beaniehut-nade-prac',
  'bears-concept',
  'bears',
  'beastbagchasers',
  'beboldgg',
  'bee',
  'beendope',
  'beer-and-cigs',
  'beerleagyue',
  'beermoney',
  'begenius-esc',
  'begrip-gaming',
  'begrip',
  'begynki',
  'behop',
  'bekescsabai-egyesulet',
  'bekescsabai',
  'belfast-storm',
  'belgium',
  'ben-clan',
  'benadryl-abusers',
  'benamisos',
  'bence',
  'benched-gods',
  'beneath',
  'benimobroderna',
  'berg',
  'berzerk',
  'besiktas',
  'bestia-academy',
  'bestia',
  'bet-m',
  'betafarmers',
  'betboom',
  'betclic',
  'betera',
  'beyman-elite',
  'beyman-esports',
  'beyman-titan',
  'beyman-vortex',
  'beyond-esports',
  'beyond-limits',
  'beyond-ruim',
  'beyond',
  'bez-zarplatbl',
  'bez-zp',
  'bgns-esports',
  'bh3-esports',
  'bh9k',
  'bhop',
  'bifrost',
  'big-5-esports',
  'big-5',
  'big-academy',
  'big-addy-daddys',
  'big-beefers',
  'big-chillin',
  'big-deag-energy',
  'big-equipa',
  'big-fish',
  'big-frames',
  'big-gods',
  'big-kahuna-gaming',
  'big-omen-academy',
  'big-rig-beasts',
  'big-tarsh',
  'big-truss',
  'big-water',
  'big',
  'bigbrainnoaim',
  'bigdirtyesports',
  'bigfoot-mercenary-gaming',
  'biggamemen',
  'biggiecheesefanclub',
  'bigodes',
  'bigpharma',
  'bigthree',
  'bigtime-regal',
  'bijoux',
  'bike-thieves',
  'binary-dragons',
  'bing-bong',
  'binger-kong',
  'bink',
  'binky',
  'bird-lickers',
  'bird-squishers',
  'birminghamsalvo',
  'biscuitsngravey',
  'bit-esports',
  'bit',
  'bitfix',
  'bitfixgaming',
  'bitshock',
  'bittersweet',
  'bizarre-gaming',
  'bizarre',
  'bizon-prime',
  'bjornbrothers2',
  'bl4ze',
  'black-dragon-society',
  'black-dragon',
  'black-dragons-fe',
  'black-dragons',
  'black-mold',
  'black-phoenix',
  'blackhat-esport',
  'blackjackals',
  'blacklaminate',
  'blackouted',
  'blacksea',
  'blahaj',
  'blaze-warriors',
  'blazing-beavers',
  'blazing-parrots',
  'blazingstar',
  'bleed',
  'bleiz-clan',
  'bleiz',
  'blessed',
  'blight-gaming',
  'blight',
  'blink',
  'blitzkrieg',
  'blnk',
  'blood-torva',
  'bloodline',
  'bloodpro-esports',
  'bloody-crystal',
  'bloom',
  'bloons-tower-defense-6',
  'bloons',
  'blue-hebrews',
  'blue-killer',
  'blue-lock',
  'bluejays-agency',
  'bluejays-empire',
  'bluejays-royal',
  'bluejays-train',
  'bluejays-zoo',
  'bluejays',
  'blueotter-karma',
  'blueprint',
  'bluesolo',
  'bluestones',
  'blvkhvnd',
  'bm-esports',
  'bmz',
  'bnp',
  'bo4ka-piva',
  'boathousev2',
  'bobers',
  'boca-juniors',
  'boiets',
  'boiler-boys',
  'bom-tempo',
  'bomb-squad',
  'bombok',
  'bongoneiro',
  'bongripper',
  'bonk',
  'boogie-boyz',
  'boom',
  'boomer-gang',
  'boomer-squad',
  'boomer-tumor',
  'boomesports',
  'boomshake',
  'boomslang-gang',
  'boop-boop-gang',
  'boosting-piksuk',
  'boot',
  'booty-sniffas',
  'bootybroacademy',
  'booz-cluez',
  'boring-player',
  'boring-players',
  'born-in-mongolia',
  'born-of-fire',
  'born-to-fluke',
  'born2throw',
  'boss',
  'boston-shaq',
  'bottomfeeders',
  'bounty-hunters-rising',
  'bounty-hunters',
  'bourzoi-klub',
  'bozos',
  'bpcsgo',
  'bpro-gaming',
  'brader',
  'brahmas',
  'brain-busters',
  'brain-fog',
  'braindead',
  'bramptondrivers',
  'braustardos',
  'bravado-gaming',
  'bravado',
  'brave-bears',
  'brave-soldiers',
  'bravos-gaming',
  'bravos',
  'brazen',
  'brazylijski-luz',
  'bread-bandits',
  'breakaway-esports',
  'breakaway',
  'breakthrough',
  'breidablik',
  'bremsnesacademy',
  'bren',
  'brest-esport',
  'brisbane-deceptors',
  'brocks-birds',
  'broda',
  'brodyyyginr',
  'broken-e-sport',
  'brothermans-',
  'brothers-united',
  'brugge',
  'brussels-guardians',
  'brusselsprout',
  'brutal',
  'brute-academy',
  'brute-evolution',
  'brute-force',
  'brute-juniors',
  'brute',
  'brzcas',
  'btc-bandits',
  'bth-esports',
  'bth',
  'btrg',
  'bubble-buddies',
  'bubibabu',
  'bucce-force',
  'buck-nasty',
  'bucketjonsboys',
  'budajiugun',
  'budapest-5',
  'budapest-five',
  'budapest5',
  'buddha-pests',
  'buds',
  'buff-chick-peet',
  'buff-nuts68',
  'buffalo',
  'bug-event',
  'bugatti-music',
  'buhm',
  'buk-choi',
  'bulgaria',
  'bulldozer-esports',
  'bulls-95',
  'bunker-esport',
  'bunkkerigg',
  'bunny-boys',
  'burn',
  'bushido-boyz',
  'bushido-wildcats',
  'bussy-banditos',
  'butterfly',
  'buykey-esports',
  'buzzkill-esports',
  'bwc',
  'bx3-esports-club',
  'by-any-means-necessary',
  'byzantine-raiders',
  'c-est-la-vie',
  'c-generation',
  'c0ntact-gaming',
  'c0ntact',
  'c0re-esports',
  'c0re-purple',
  'c4-base',
  'c4-gaming',
  'c4pybaras',
  'cabana-vip',
  'cabo-verde',
  'caladrius',
  'calamity',
  'calaoscornos',
  'caldya',
  'call-me-lvge',
  'calmrthanyouare',
  'camel-riders',
  'camlica',
  'camo',
  'campus-vejle-flammen',
  'campus-vejle',
  'canon-event',
  'capybara-esport',
  'caracol-gigante',
  'carbonx-esports',
  'careperrove',
  'caretos',
  'cargorun',
  'carnage-esports',
  'caronte',
  'carrion',
  'carritospain',
  'carte-blanche',
  'cartoonxcrushez',
  'cascadia',
  'case-esports',
  'case-hardy-boyz',
  'case',
  'caseking-gaming',
  'cash-cows',
  'casta',
  'cat-dad-gamers',
  'cataclysm',
  'catchii',
  'category-5',
  'catevil',
  'catpiss',
  'catswithstaches',
  'caught-off-guard',
  'cavaniagent',
  'cavehubbers',
  'caz-esports',
  'cb-gaming',
  'cbump-team',
  'cc-oglum',
  'ccg-esports',
  'ceara',
  'cebolos',
  'celestial-esports',
  'censored',
  'center-gaming',
  'center-talent',
  'central-fs',
  'centralfinancia',
  'cepter-bitskins',
  'cepter',
  'cerberusesports',
  'cesu-blck',
  'cex-eps',
  'cex',
  'cg',
  'chama',
  'champ',
  'champagne-gaming',
  'champions2007',
  'chamypl',
  'change-the-game',
  'changuitopeek',
  'chaos-champions',
  'chaos-enforcers',
  'chaos-esports-club',
  'chaos',
  'chaox-esports',
  'chaoz-esports',
  'chaoz-gold',
  'chapmans',
  'chaseisbad',
  'checkmate',
  'checksix-gaming',
  'cheems-love',
  'cheeseltd',
  'chemtrails',
  'cherry-bombs',
  'chetz-esports',
  'chetz',
  'chicken-coop-esports',
  'chicken-coop',
  'chiefs-esports-club',
  'chiefs',
  'chilinboys',
  'chill-dongas',
  'chill-guys',
  'chill-zone',
  'chillidill',
  'chimera',
  'chimpaim',
  'china-gamers',
  'chinanocan',
  'chinese-puggers',
  'chinggis-warriors',
  'chissoku-suru',
  'chococheck',
  'chokbar',
  'choke-gaming',
  'chopped-bruzz',
  'chopped',
  'chosen5',
  'chroma',
  'chuck-e-cheese',
  'chucklestorm',
  'chudo-yudo',
  'churrrros',
  'ciao-scuzzi',
  'cicadas-gaming',
  'cierzo-esports',
  'cillerian',
  'circuitesc',
  'citim-tanecno',
  'citron-esport',
  'citron',
  'city-boys-up',
  'cityboyz',
  'ck0poct6',
  'cl-showbobs',
  'clam-lips',
  'clan-mystik',
  'clap-squad',
  'clase-azul',
  'classless',
  'claymakers',
  'cleaningourdesk',
  'cleantmix',
  'clg-red',
  'clickt',
  'climbers',
  'climbo',
  'close-society',
  'cloud-gaming',
  'cloud9',
  'clowncar-legacy',
  'clowncar-unchained',
  'clowncar',
  'club-333',
  'club-brugge',
  'cluckers-inc',
  'clutch-gaming',
  'clutch-kings',
  'clutch-rayn',
  'clutch-solutions',
  'clutch',
  'clutchain-fe',
  'clutchain',
  'clutchit',
  'clutchmonkeys',
  'cmd',
  'cnb-e-sports-club',
  'coalesce',
  'coastal-esports',
  'cobros-cobros',
  'cocacherie',
  'cocaine-cowboys',
  'cockroach',
  'cod-kids',
  'codewise-unicorns',
  'codmaniacs',
  'cog',
  'cohesion',
  'cojomo-academy-roster',
  'colales-de-b',
  'collateral',
  'colorsgaming',
  'coluant',
  'comautusgg',
  'comedyclub',
  'comet-clan',
  'comet-crew',
  'common-atom',
  'complexity-gaming',
  'complexity',
  'conduit-esports',
  'connector-one',
  'conquer-esports',
  'conquer-gaming',
  'conquer',
  'conquergg',
  'conquest',
  'conquistadors',
  'consanguin',
  'conscious-gaming',
  'constrictgaming',
  'contact-light',
  'control-esports',
  'control',
  'convicted',
  'cooked',
  'cool-academy',
  'cool-fellas',
  'cool-gaming',
  'cool-juniors',
  'coolermaster',
  'coolnmysterious',
  'coop-de-grace',
  'coordinated-disrespect',
  'copenhagen-flames',
  'copenhagen-wolves',
  'copper-goblins',
  'core',
  'corinthians-academy',
  'corinthians-cds',
  'corinthians',
  'corrupt-esports',
  'corvidae',
  'corvus-corps',
  'coscu-army',
  'cosmic-serpents-gaming',
  'cosmoss-riga',
  'cossacks',
  'costcappen',
  'costco-family',
  'costco-guys',
  'counter-logic-gaming-red',
  'counter-logic-gaming',
  'counter-nature',
  'counterspec',
  'counterstreakrs',
  'counterstrike-team',
  'coupdegrace',
  'courage',
  'courageg',
  'coven',
  'cowana',
  'cpc-curralzinho',
  'cph-esport',
  'cph-wolves',
  'cplay',
  'cplm',
  'cr4zy',
  'crashers',
  'crashout',
  'cream-real-betis-sa',
  'cream-real-betis',
  'cream',
  'creative-avez',
  'creatorpeek',
  'creed',
  'crep-xtreme',
  'crescent',
  'crime-squad',
  'crimson-vortex',
  'cringe-gods',
  'crispy-noodles',
  'cristianoronald',
  'critical-chaos',
  'crossfire-team',
  'crowcrowd',
  'crsnt-roze',
  'crunchybagels',
  'cruzeiro',
  'cryptex-florum',
  'cryptova',
  'cs-kings',
  'cs-nightmares',
  'cs-uw',
  'cs2antitalents',
  'cs2lens-logo-v2',
  'cs2news',
  'cs2team',
  'csde-cantera',
  'csde',
  'csdiilit',
  'csfail',
  'csgo',
  'csgo2x',
  'csgoats',
  'csgoatse',
  'csgocasino',
  'csgonads',
  'csgopositive',
  'csta-2',
  'csta',
  'csw-esports',
  'ctak-sobak',
  'ctrl-alt-defeat',
  'ctrl',
  'cube-cyber',
  'cubera',
  'cult',
  'culturedthugs',
  'cum-chasers',
  'cumbup',
  'cunning-ruse',
  'cupava-veverica',
  'curbside-dental',
  'curlews',
  'curralzinho',
  'curse-gaming',
  'curve50',
  'cutiewutie',
  'cvc-academy',
  'cw-academy',
  'cxirk',
  'cyaatthemajor',
  'cyber-empire',
  'cyber-hero',
  'cyber-kuban',
  'cyber-legacy',
  'cyber-ninjas',
  'cyber-park-arena',
  'cyber',
  'cybershoke-prospects',
  'cybershoke',
  'cyberspace-ua',
  'cyberstorm-blue',
  'cyberstorm',
  'cyberstorn-blue',
  'cyberx-khabarovsk',
  'cyberzen',
  'cyclonegg',
  'cynder',
  'cynical5',
  'cynicals',
  'cyxariki',
  'czech-republic',
  'd13',
  'd1jar1peek',
  'd1nk-esports',
  'd2-esports',
  'd3bils',
  'da-jokas',
  'da-kore',
  'daaku',
  'daddick-esports',
  'daddies',
  'daddys-lil-men',
  'dadongbeicypher',
  'dadpeek',
  'dads-that-vape',
  'dadsclub',
  'dakko-team',
  'daluyong',
  'damage-control',
  'damajuana',
  'damnstar-esports',
  'dancompany',
  'dangle',
  'danishpotatoes',
  'dankermemerson',
  'dans-ta-yeule',
  'daotsu',
  'dapper-north',
  'darias-gamers',
  'dark-knight',
  'dark-matter-esports',
  'dark-moon',
  'dark-passage',
  'dark-sided',
  'dark-tigers',
  'darkaces',
  'darkest-hour',
  'dash',
  'dat-team',
  'datura',
  'davenport-university',
  'dawg-walkers',
  'dawg-walking-backwards',
  'dawgz',
  'dayhope',
  'daystar',
  'db-peek-esports',
  'db-store',
  'dbl-poney',
  'de-eznuts',
  'de-generates',
  'de-stroyed-p2',
  'de-stroyed',
  'de-throne',
  'de-verdwaalde-honden',
  'dead-in-brain',
  'dead-pixel',
  'deadpixels',
  'death-squad',
  'death-trap-e-sports',
  'deathxgamers',
  'deep-cross',
  'deepcrossgaming',
  'deepfriedfrenz',
  'defeaters',
  'deftfox',
  'defusekids',
  'defyant',
  'degen-gamblers',
  'degen-woody-cs',
  'deja-vu',
  'deli-cinq',
  'delta-division',
  'delta-syndicate',
  'delta',
  'demise',
  'demolition-crew',
  'demolition',
  'demon-factory',
  'demons',
  'dendd',
  'dendele',
  'denial-esports',
  'denied',
  'denizbank-iwc',
  'denmark',
  'dennys',
  'deorum',
  'depo-esports',
  'depo-premium',
  'depo-team',
  'depo',
  'depre',
  'depreso-reborn',
  'depression',
  'depressumhaedos',
  'depth',
  'deranged-esports',
  'derptuah',
  'desconocidos',
  'desi-boyz-v6',
  'desire-2-excel',
  'desolate',
  'despair',
  'desperados-cs2',
  'destruct',
  'detdom-boys',
  'detona-gaming',
  'detona',
  'detonate-academy',
  'detonate',
  'detonator',
  'deus-lux',
  'deviance',
  'devils-one',
  'devils',
  'devious',
  'dewa-united',
  'dexterity',
  'dg-esports',
  'dgg',
  'dhala',
  'dhlg',
  'dial-it-in',
  'dialed-en',
  'diamant-esports',
  'diamant',
  'diamond-mental',
  'dice',
  'diffendo',
  'digital-wave',
  'dignitas-fe',
  'dignitas',
  'diminish',
  'dimonix',
  'dindinz',
  'ding-cuts',
  'dingleberries',
  'dingtone',
  'dinq',
  'dippers',
  'dipstellar',
  'dire-wolves',
  'dire',
  'directors-team',
  'dirt-gang',
  'dirtbags',
  'dirtjackerz',
  'dirty-deaglers',
  'dirtyslayers',
  'disband-team',
  'discocat',
  'discoskridsko',
  'discotaxi',
  'distinguished-ducks',
  'district-7',
  'divebar',
  'divergent',
  'diversity',
  'divina-fe',
  'divina',
  'divine-vendetta',
  'divine',
  'divinity',
  'divizon',
  'djoufara',
  'dms',
  'dn-gaming',
  'dna',
  'dng',
  'dnipro',
  'dnmk',
  'dobryandgaming',
  'doc',
  'dodep-team',
  'dodg3rs',
  'dodge-team',
  'doge-soldiers',
  'dogg-peek',
  'dogmination',
  'dogs-of-war',
  'dogs',
  'dogshtters',
  'dogshxtmilitia',
  'dogwater',
  'dojo',
  'dolus-gaming',
  'dom-towarowy',
  'domerock',
  'dominance-blue',
  'dominatus',
  'domino',
  'dominoz',
  'donstu-esports',
  'donstu',
  'dont-trip',
  'doodlebob',
  'doomfury',
  'doomgg',
  'doski',
  'dot-stats',
  'dotpixels-e',
  'dotstats',
  'double-cream',
  'double-damage',
  'double-eruption',
  'double-poney',
  'down-to-frag',
  'down2earth',
  'downbadcs',
  'downfall',
  'doxa-gaming',
  'doxa',
  'dozera',
  'dp-bandits',
  'dp-man',
  'dpg-gaming',
  'dpg',
  'dqzs',
  'dr',
  'dr',
  'draconic',
  'dracula-flow',
  'dragon-esports',
  'dragons-ec',
  'drags',
  'drama',
  'dream-chaser',
  'dream-fire',
  'dream-s-cape',
  'dream',
  'dreameaters',
  'dreamer-esports',
  'dreams2legends',
  'dreamscape',
  'dreamstolegends',
  'dreamwalkers',
  'dreamworks',
  'drgn',
  'drillas-academy',
  'dripmen',
  'drippy-lab',
  'droidjays',
  'drop-bears',
  'dropdeadgaming',
  'drugs-n-pugs',
  'drunkdrivers',
  'drypeekgaming',
  'dtl',
  'dts-gaming',
  'duality',
  'duangduang',
  'dubnica-academy',
  'duck-crew',
  'duckduckgoose',
  'ducks',
  'duggedup',
  'dumbo',
  'dummied',
  'dunahauztemze',
  'dunderhonung',
  'duoq-ulkohuus',
  'durany-rising',
  'durany',
  'dusty-roots',
  'dusty',
  'dusty',
  'duuhsquad',
  'dvgames',
  'dxa',
  'dynamics-team',
  'dynamo-eclot-thunders',
  'dynamo-eclot',
  'dynasty-na',
  'dynasty',
  'dynastyesc',
  'e-frag',
  'e-galo',
  'e-town-gaming',
  'e-wolves',
  'e-xolos-lazer',
  'e9-esports',
  'e9',
  'eac',
  'eachofus',
  'eagleeyeacademy',
  'east-melons',
  'eastside',
  'easypeasy',
  'ebea2',
  'eber-red',
  'ebro',
  'ec-banga',
  'ec-genk',
  'ec-kyiv',
  'ec-livonia',
  'ecc-kats',
  'echo-fox',
  'eclezya-esport',
  'eclige-reborn',
  'eclipse',
  'eclot-gaming',
  'eclot',
  'eco-sport-rebaxada',
  'eco-warriors',
  'ecogoblins',
  'ecstatic',
  'edemdomoy',
  'edgebugoffsilo',
  'edlt',
  'edward-gaming',
  'eeepy-time-crew',
  'eeffoc',
  'eefsports',
  'eeriness',
  'efrog',
  'eg-black',
  'eg-gold',
  'eg',
  'eg',
  'eg0ism',
  'egg-clan',
  'eggzibit',
  'ego-accendent',
  'egoisto',
  'ehome',
  'eidos',
  'eitonnepaase',
  'ejax-jaguars',
  'ek-cskeisari',
  'ek-vellamo',
  'ek-violet',
  'ekasi',
  'eko',
  'el-chombos-fan-club',
  'el-es-pi-di',
  'el-gato-club',
  'elation',
  'eldsjalar',
  'electrify-steel',
  'electrocuted',
  'electronik-generation',
  'elemental',
  'elementgamingc',
  'elements-pro-gaming',
  'elevate-gg',
  'elevate',
  'elfeex-team',
  'elfeex',
  'elite-klan',
  'elite-riflers',
  'elitemilijoet',
  'elites',
  'elnationale',
  'elo-farmers',
  'elo-terrorists',
  'elothrowers',
  'elusive',
  'elysian-fields',
  'elysium',
  'ember',
  'embition-ec',
  'emc',
  'emc2-esports',
  'emerald-isle',
  'emeritos-banditos',
  'emerytura',
  'emi',
  'emocats',
  'empire',
  'employed',
  'emulate!',
  'en-kerro',
  'ence-academy',
  'ence-athena',
  'ence-esports',
  'ence-prospects',
  'ence',
  'encore',
  'endangered',
  'endgame',
  'endless-esports',
  'endless-journey',
  'endless-reign',
  'endlessflow',
  'endpoint-academy',
  'endpoint-cex',
  'endpoint',
  'eneida',
  'enemy',
  'energie',
  'energise-club',
  'energy-esports',
  'energy',
  'energyultra',
  'enervate-gaming',
  'enginebr',
  'enigma',
  'eniman-has-kit-in-bold',
  'enjoy',
  'enjoy',
  'enjoy1',
  'enjoyers',
  'enormity',
  'enosis-esport',
  'enosis',
  'enosiscr',
  'enosiscs',
  'enrage',
  'enro-griffins',
  'ensky-esports',
  'enso',
  'enterprise-esports',
  'enterprise-gen',
  'enterprise',
  'entertainment-cheese',
  'entity-gaming',
  'entropiq-future',
  'entropiq-prague',
  'entropiq-queens',
  'entropiq',
  'entropy-future',
  'entropy-gaming',
  'entropy-youth',
  'entropy',
  'envy',
  'envyus-academy',
  'enyoy',
  'enzo',
  'ep-prodigy',
  'ep',
  'epic-dude',
  'epic-dudes',
  'epicdudes',
  'epikk-esports',
  'epiphany-bolt',
  'epochal-esports',
  'epoka-lodowcowa',
  'epsilon-esports',
  'eq-gaming',
  'eqole',
  'equasion',
  'era',
  'erau-esports',
  'erciyes',
  'erebus',
  'erlamand',
  'ermm',
  'eros-red',
  'eros',
  'eruption',
  'ervelo',
  'esahara',
  'esc-academy',
  'esc-gaming',
  'esc',
  'esca-gaming',
  'esca',
  'escape-gaming',
  'escape-velocity-esports',
  'escapist',
  'esg',
  'esh-rebels',
  'esimed',
  'esmagab',
  'espada',
  'esper',
  'espionage-br',
  'espionage',
  'esport-alltech',
  'esport-factory',
  'esport-harte-',
  'esport-harte',
  'esport-rhein-neckar',
  'esports-cologne',
  'esports-gaming-reborn',
  'esports-gloodys',
  'esports4extreme',
  'esprots',
  'espuma',
  'esu',
  'esuba-at',
  'esuba-white',
  'esuba-youngsters',
  'esuba',
  'eta',
  'etab',
  'etb-speedrunner',
  'eternal-21',
  'eternal-fire-ac',
  'eternal-fire-academy',
  'eternal-fire',
  'eternal-focus',
  'eternal-nullard',
  'eternal-premium',
  'eternal-valor',
  'eternals-gaming',
  'eternity-gaming',
  'ethereal',
  'etherian',
  'ethos',
  'ett',
  'eucl-prodigies',
  'eucl-sicarios',
  'eunited',
  'euronics-gaming',
  'evarus',
  'evicted',
  'evidence-e-sports',
  'evil-corp',
  'evil-geniuses',
  'evil-legion',
  'evil-side',
  'evil-space-wizards',
  'evilelk',
  'evilnine',
  'evilspacewzards',
  'evo-novo',
  'evokate-gaming',
  'evolupegg',
  'evolution',
  'evolve',
  'evolved-gaming',
  'evoplay',
  'ewave-esports',
  'ewave',
  'ewe-posidim',
  'ewm-gaming',
  'ex-altay-espor',
  'ex-astris',
  'ex-coalesce',
  'ex-diverse',
  'ex-ec-brugge',
  'ex-endpoint-cex',
  'ex-enhanced',
  'ex-flames-ascent',
  'ex-gators',
  'ex-godsent',
  'ex-ltl',
  'ex-mt',
  'ex-poohank',
  'ex-rhynoyung',
  'ex-uhka-esports',
  'ex-xi-esport',
  'exaequo-italia',
  'exalis',
  'exalty',
  'exaustic',
  'excellency',
  'exceritus',
  'excessiveofaim',
  'excuse-me',
  'exdee-gaming',
  'exdee',
  'exdt',
  'execute-meso',
  'executioners',
  'exen-academy',
  'exen',
  'exertus-esports',
  'exhibit',
  'exich',
  'exilium',
  'exloders',
  'exo',
  'exodia-peek',
  'exodian',
  'exodus',
  'exousia-esports',
  'experiment-one',
  'expert-esport',
  'expert-gaming',
  'exploit-esports',
  'exploit',
  'explosive',
  'exsad-gaming',
  'exsad',
  'exsequor',
  'exsto',
  'extatus',
  'extra-salt',
  'extra-tilt',
  'extremix',
  'extremum',
  'extricity',
  'exusiai',
  'exynt',
  'exzentriq-utd',
  'eye-of-horus',
  'eyeballers',
  'eyesports',
  'eys-esports',
  'ez-cheeks',
  'ez2025',
  'ezcaladreipo',
  'ezentify',
  'ezpz-',
  'ezpz',
  'ezskins',
  'eztbh',
  'f1lthy-puggers',
  'f1washedcar',
  'f4f',
  'f5-esports',
  'f5',
  'fa-white',
  'fab-games-esport',
  'facecal',
  'facewreckers',
  'fact-revolution',
  'factory-242',
  'factory-esport',
  'factory-reset',
  'fade',
  'faded-squad',
  'fadee',
  'failure-lab',
  'faint-gaming',
  'fairies',
  'fajne-chlopaki',
  'fak1e-lab',
  'fakaforfragero',
  'fake-do-biru',
  'fake-esport',
  'fakeit',
  'falcons-force',
  'falcons',
  'falke-academy',
  'falke-ec',
  'falkn',
  'falkol',
  'fallen-legion',
  'fam143',
  'famalic-o',
  'famas-op-on-t-s',
  'famas-op',
  'familia',
  'family-table',
  'family',
  'familybroken',
  'familytherapy',
  'fang-esport',
  'fantasia',
  'fantastic-seven',
  'faraon',
  'farsa-clan',
  'fastmen',
  'fat-esport',
  'fate-mena',
  'fate',
  'fated',
  'fathom-gaming',
  'favbet',
  'favela-monkas',
  'fawk-archer-guy',
  'faze-clan',
  'faze',
  'fbg',
  'fc-synti',
  'fcz',
  'fearferox',
  'feelings-wheel',
  'feels-im-man',
  'feels-main-man',
  'feenix',
  'feetenjoyers',
  'fefe-fan-club',
  'felt',
  'femboy-lovers',
  'fengda',
  'fenix-team',
  'fenix',
  'fentanylfriends',
  'festina-lente',
  'fever-squad',
  'ff-when',
  'fidelity',
  'fides-eques',
  'fiend',
  'fierce-esports',
  'fiftyeight',
  'fightclub',
  'fighters',
  'filhos-de-d10s',
  'filledcrisps',
  'filthy-casuals',
  'final-feature',
  'final-gaming-speedlink',
  'finalform',
  'finest',
  'fingers-crossed-fe',
  'fingers-crossed',
  'finishers',
  'fire-capes-only',
  'fire-dragoon-e-sports',
  'fire-flux-titanseat',
  'fire-flux',
  'firegamers',
  'firesale',
  'firewolf-clan',
  'first-memory',
  'fisher-college',
  'fistbumpsonlan',
  'fitnessclubcs',
  'five-kings',
  'five-legends',
  'five-noname',
  'fivegubbz',
  'flame-sharks',
  'flamehard',
  'flamencos',
  'flamengo',
  'flaming-north',
  'flamingflamingo',
  'flares-esport',
  'flash-gaming',
  'flat-earth',
  'flavor-town',
  'flawless',
  'flexibility',
  'flg',
  'fli6ht-gaming',
  'flickgame',
  'flipsid3-tactics',
  'flisk',
  'floki-hellheim',
  'floki-main',
  'flood',
  'florida-man',
  'floripa-stars',
  'flostate',
  'flourish-gaming',
  'flow-state',
  'flow',
  'flowsta',
  'fluffy-aimers',
  'fluffy-gangsters',
  'fluffy-youngs',
  'fluffygangsters',
  'fluxia',
  'fluxo',
  'flying-penguins',
  'flyingh1rsch',
  'flyquest-red',
  'flyquest',
  'fmesports',
  'fn-esports',
  'fnatic-academy',
  'fnatic-rising',
  'fnatic',
  'fnbet',
  'fnp-esports',
  'focal-joint',
  'focal-point',
  'focus',
  'foggy-esports',
  'fokus-reality',
  'fokus',
  'follow-please',
  'fomichevswg',
  'for-the-ages',
  'for-the-win-esports',
  'for-the-win-evolution',
  'for-the-win',
  'forbidden',
  'force-majeure',
  'force-of-nature',
  'force-one-store',
  'foreground',
  'forever-youngs',
  'forge',
  'forgetabitcuh',
  'forglory',
  'fork-lifters',
  'forklift-certified',
  'formidable',
  'forsaken',
  'fortis',
  'fortress-esport',
  'fortress-main',
  'fortress',
  'fortuna-esports',
  'forward-gaming',
  'forward',
  'forze-reload',
  'forze-yng',
  'forze',
  'four-magic',
  'fourstrokegang',
  'fourteen',
  'fourth-quarter',
  'foxed',
  'foxnyr-esports',
  'foxton',
  'foxtrot',
  'fr34k2',
  'frag-executors',
  'fragbox',
  'fragdemons',
  'fraggin-out',
  'fragmatic',
  'fragsters',
  'france',
  'fraternitas',
  'fraternity-',
  'fraternity',
  'fraud-esports',
  'frauds-academy',
  'frauds-season',
  'frauds',
  'fraudsterscs',
  'freaksoflegend',
  'freaky-five',
  'free-elo',
  'free-frugz',
  'free-ton',
  'free-win-sweep',
  'freealex2k',
  'freelanders',
  'freestyle',
  'french-nation',
  'frenchfrogs',
  'fresh-js-squad',
  'friendly-fire',
  'friendlyfire',
  'friendshippower',
  'friendsofbryan',
  'frig-archer-guy',
  'frikitonagaming',
  'frostfire',
  'fruchtlabormain',
  'frukimota',
  'frutto-drillo',
  'ftw-ashes',
  'ftw-esports',
  'ftw-madalentejo',
  'ftw',
  'fuark',
  'fuck-helicopters',
  'fudge-packers',
  'fueled-by-hate',
  'fulcrum-esports',
  'full-circle',
  'full-house',
  'full-tilt',
  'full-white',
  'fullgaz',
  'fullshock',
  'fullshockgamers',
  'fullspectrumsqd',
  'funplus-phoenix-blaze',
  'funplus-phoenix',
  'furia-academy',
  'furia-esports',
  'furia-fe',
  'furia-female',
  'furia-gaming',
  'furia',
  'furio-reloaded',
  'furious-argentina',
  'furious-gaming',
  'furious',
  'fury-finesse',
  'fury',
  'furya',
  'fusion-esport',
  'fut-academy',
  'fut-turkuaz',
  'fut',
  'fuzos',
  'fwrd',
  'fylkir',
  'fyr',
  'g-pro',
  'g0dbless',
  'g2-ares',
  'g2-esports',
  'g2-oya',
  'g2',
  'g3-',
  'g3nerationx',
  'g4yhound',
  'gaddar-esport',
  'gaidamaks',
  'gaijin',
  'gaimin-gladiators',
  'galacticos',
  'galatic-goonz',
  'galaxy-brains',
  'galaxy-gaming',
  'galaxy-gas-gang',
  'galaxy-racer-fe',
  'galaxy-racer',
  'galaxygaming-lt',
  'galia-esport',
  'gallus-gamers',
  'galorys',
  'gambit-esports',
  'gambit-gaming',
  'gambit-youngsters',
  'gambit',
  'gamblersanonymo',
  'game-agents',
  'game-fist',
  'game-is-game',
  'game-life-balance',
  'game-point',
  'game-pub',
  'game-pulse',
  'gameagents-ac',
  'gameagents',
  'gamefist',
  'gameharmony',
  'gamehunters',
  'gameover',
  'gameplaydna',
  'gamepub',
  'gamepulse-czech',
  'gamerhands',
  'gamerlegion',
  'gamers-anonnymous',
  'gamers-anonymous-clan',
  'gamers-anonymous',
  'gamers2',
  'gamerslab',
  'gamerzone',
  'games-academy',
  'gamesport',
  'gametv',
  'gamezone',
  'gaming-memories',
  'gamingpenguins',
  'gamja-namjas',
  'gamuzo-esports',
  'gang',
  'garaza',
  'garazagg',
  'garden-garage',
  'garden-gnomes',
  'garfieldclub',
  'gate-keepers',
  'gateron',
  'gator-pit',
  'gatorian',
  'gbcxz',
  'gbh-gang',
  'gbots-esports-club',
  'gcsy',
  'gd-chaves',
  'gdansk-lions',
  'ge-silver',
  'gecko-esports',
  'gecko-main',
  'gedza',
  'geekz-academy',
  'geekz-de',
  'geekz-energy-de',
  'geekz-energy',
  'geishakuulat',
  'gem-reborn-v3',
  'gemuend',
  'gen',
  'genaaide-boys',
  'generation-y',
  'genesik-gaming',
  'genesis',
  'genesium',
  'genetexe',
  'geneticdiff',
  'genk',
  'genone-academie',
  'genone',
  'gentle-mates',
  'genuine-gaming',
  'genuine',
  'geny-gg',
  'genz-blue',
  'genz',
  'gerber-peek',
  'germany',
  'get-fked',
  'getting-good-v1',
  'getting-good-v3',
  'geud-gaming',
  'gf-gaming',
  'gg-arena-kaunas',
  'ggconquer',
  'ggp-clan',
  'ggpr',
  'ggwp',
  'ghost-gaming',
  'ghost',
  'ghoulsw',
  'ghr-e-sports-',
  'giants-gaming',
  'giants',
  'giddeygoons',
  'giga',
  'gigx',
  'gimmik-pearls',
  'gines-horsemen',
  'girl-kissers',
  'girth-kitties',
  'gjrosesvanz',
  'gkc',
  'gl-academy',
  'gl44n1',
  'gleck18-esports',
  'glichtech',
  'glips',
  'glitch',
  'glitchtech',
  'glizzy-gobblers',
  'glock-blockers',
  'glock-gobblers',
  'glockdoctors',
  'glockwork',
  'glore',
  'glorious-esport',
  'gluten-demons',
  'gmt',
  'go-next',
  'go5y',
  'goart-on-it',
  'goashax-algeria',
  'goashax',
  'goats',
  'gobananas',
  'goblin-esports',
  'goblinaim',
  'gochu-gobblers',
  'god-bets',
  'god-complex',
  'god-squad',
  'god-timing',
  'godamn',
  'godlike-goats',
  'gods-reign',
  'gods-work',
  'godsent-academy',
  'godsent-fe',
  'godsent',
  'godzillax',
  'goin-huge',
  'gojos',
  'golden-five',
  'golden-time',
  'golden',
  'goldenv',
  'goliath-gaming',
  'goliath',
  'golira',
  'golovastiki',
  'gomi-dot-club',
  'gonext-esports',
  'gonomore',
  'gonshiki-legit',
  'goober-gang',
  'goobgob',
  'gooblers',
  'good-for-three',
  'good-game-pr',
  'good-game-spot',
  'good-game',
  'good-guy-team-2',
  'good-luck-tej',
  'good-vibes-only',
  'goodcall',
  'goodgame',
  'goodjob',
  'goofball-gamin',
  'goofball-gaming',
  'goofy-gooberz',
  'google-docs',
  'goon-squad',
  'gooner5',
  'goons-',
  'goopt',
  'gooshedd',
  'goozpeek',
  'gorilla-mode',
  'gorilla-tactics',
  'gorilla',
  'gosu',
  'gotango',
  'gothboiclique',
  'gouc',
  'gourmet-guild',
  'goyim-gladiators',
  'gp-esports',
  'gplay',
  'gr-mio',
  'gr',
  'gr4ndpa-go0nz',
  'graf-monte-cristo',
  'grand-masters',
  'grandmawalkers',
  'grandpa-berets',
  'granit-gaming',
  'granit',
  'grannys-knockers',
  'grannysknockers',
  'granted',
  'grass-touchers',
  'graveyard-peek',
  'graveyard-shift',
  'graveyard',
  'gravity-0',
  'gravy-train',
  'gray-wolf',
  'grayfox',
  'grayhound-gaming',
  'grayhound',
  'great-burritos',
  'greatapes',
  'green-tea-party',
  'greenwhite',
  'gregs-new-cut',
  'gremlenbl',
  'griefers',
  'griffins-es',
  'grilled-chicken',
  'grim-job',
  'grindas',
  'grip-n-spin',
  'grogu',
  'grond',
  'ground-zero-gaming',
  'ground-zero',
  'grow-up-esports',
  'grow-up',
  'grubhub',
  'gruspivteam',
  'gruv-co',
  'gryptionacademy',
  'gtz-bulls-esports',
  'gtz-bulls',
  'gtz-esports',
  'gtz',
  'gtz',
  'guangdong-tigers',
  'guangdongtigers',
  'guara-esports',
  'guara',
  'guaranteed-raw',
  'guardian-5',
  'guardian-esport',
  'guardians',
  'gucci-academy',
  'gucci-gaming-ac',
  'gucci-squad',
  'guccisqd',
  'guerillatactic',
  'guess',
  'guild-eagles',
  'guild-fe',
  'guild',
  'gun5',
  'guns-and-rage',
  'guns-blazin',
  'guppies',
  'gux-friends',
  'guys-bein-dudes',
  'guys-i-lagged-out',
  'gvc',
  'gwms-gamingclub',
  'gx',
  'gyrocopter-ua',
  'h00liganz',
  'h0mele55',
  'h0pe1ess',
  'h0t-academy',
  'h0t-prodigies',
  'h2k-gaming',
  'h4untedfamily',
  'ha-masse',
  'ha-matb',
  'haaste',
  'haastig-ftr',
  'habibi',
  'hacha',
  'hack-a-shaq',
  'hafo-gang',
  'hafo',
  'hail-venum',
  'hairy-scary-bandits',
  'hakka',
  'hakuna',
  'hakunamatata',
  'halal5',
  'hall-of-famers',
  'hall-of-heroes',
  'halla',
  'hallumi',
  'halow',
  'hamelspringe-ev',
  'hammerheads',
  'hamsterwarriors',
  'hanbaobao',
  'happy-people',
  'harakternyky',
  'hard-legion',
  'hard-stuck-im',
  'hardcoded',
  'hardestworkersinesports',
  'hardy-boyz',
  'harkers',
  'harte',
  'haspers',
  'hassle-x-csk',
  'hat-tossers',
  'hate',
  'hated-by-most',
  'hatemania',
  'haunted-house',
  'hauntedfamily',
  'hava',
  'havan-liberty-academy',
  'havan-liberty',
  'havens',
  'havik',
  'havocgg',
  'havu-gaming',
  'havu',
  'hawks',
  'hazard',
  'hde',
  'headcase',
  'headshot-lounge',
  'headshotbg',
  'headshotkings',
  'heatwave-esport',
  'heatwave-tmp',
  'heaven-and-hell',
  'hedgehogs',
  'heet',
  'heimo-esports',
  'heimo',
  'helenkellerpeek',
  'hell-yeah',
  'hella-ja-osujat',
  'hellcats',
  'hellraisers',
  'hellreign-ac',
  'hellside',
  'helmet-testers',
  'helmet-wearers',
  'helsinki-reds',
  'here-we-go-agen',
  'heretics',
  'hermine-esports',
  'hermine',
  'heroc1ty',
  'heroes-of-ealing',
  'heroesxvillans',
  'heroic-academy',
  'heroic',
  'heroin-monkeys',
  'hesta',
  'hexagons',
  'heyders',
  'hezos-gaming',
  'high-alert',
  'high-coast',
  'high-five',
  'high-hub-gaming',
  'high-velocity',
  'highq-esports',
  'highrollers',
  'hightrustfactor',
  'highway-robbery',
  'hihowareya',
  'hijack',
  'hijiki',
  'hikari-z',
  'hikari',
  'hillow-pumpers',
  'hite-gaming',
  'hivemind',
  'hn-university',
  'hoax-fan-club',
  'hoes-mad',
  'hoes-no-jutsu',
  'hog-riders',
  'hog-squad',
  'hokayt',
  'holesmokers',
  'holkattes',
  'holly-molly',
  'hollywood',
  'holy-squid-empire',
  'holy-trifecta',
  'holy-trifectaac',
  'homies-mt',
  'homies-ot',
  'homixide',
  'homyno',
  'honeyharvesters',
  'hongkong2001',
  'honoris',
  'honv-d',
  'honved',
  'hoorai',
  'hopium-gaming',
  'hoqeo',
  'horizon-esports',
  'horizon',
  'horny',
  'horrendous',
  'horus-esports',
  'hosers',
  'hostile-actions',
  'hot-commers',
  'hot-content',
  'hot-flash',
  'hot-headed',
  'hot-loaders',
  'hot-prodigies',
  'hotdodgers',
  'hotheadedgaming-academy',
  'hotu-esports',
  'hotu-x-elga',
  'hotu',
  'hound',
  'house-platypus',
  'housebets',
  'houstonspartans',
  'hreds',
  'hs',
  'hsl',
  'hslow',
  'huat-zai',
  'huge-sweaty',
  'huilos-gang',
  'huma',
  'hummer',
  'hummingbird',
  'hungary',
  'hunters-rising',
  'hunters',
  'huskgg',
  'huskies-esport',
  'hutt',
  'hydegg',
  'hydrohomies',
  'hyenas',
  'hype-e-sports',
  'hype',
  'hyper5cs',
  'hypergamingroup',
  'hyperion-',
  'hyperion',
  'hyperspace-dark',
  'hyperspeed',
  'hyperspirit',
  'hyperx-fr34kshow',
  'hypewrld',
  'hyro',
  'hysteria',
  'i2k',
  'ia-esports',
  'iam',
  'iberian-soul',
  'ibuymemes',
  'ibuypowder',
  'icarus-gaming',
  'ice9-e-sports',
  'icewolves',
  'icon',
  'icons-of-vanity',
  'icons',
  'identity',
  'igame-com',
  'igame',
  'ignis',
  'ignite',
  'ihc',
  'ihg-junior',
  'ikeapoyta',
  'ikla',
  'ilife',
  'ilin',
  'illegalpassport',
  'illes-akademia-spirit',
  'illes-spirit',
  'illicit-pug-pics',
  'illsint',
  'illuminar-gaming',
  'illuminar',
  'illuminargaming',
  'illusion',
  'illustrious',
  'illwill',
  'illyrians',
  'im-fine',
  'ima-problem',
  'imaginary-gaming',
  'imagine-ducks',
  'imaproblem',
  'imba-force',
  'imbadog',
  'imd',
  'img',
  'immigrants-peek',
  'immortals',
  'imp-valkyries',
  'imperators',
  'imperial-academy',
  'imperial-dragons',
  'imperial-e-sports',
  'imperial-valkyries',
  'imperial',
  'imperishable-ce',
  'imperishable-clan',
  'imperishable',
  'imperium',
  'imperiumcs',
  'impress',
  'impression',
  'impulse-gw',
  'in-bed-by-eight',
  'in-coming',
  'in-for-blood',
  'in-our-prime',
  'in-your-walls',
  'in',
  'ination',
  'incept',
  'inception',
  'inceptor',
  'inch-n-a-half',
  'incheon-on-sla2ers',
  'inchk1ng',
  'incontrol',
  'inde-irae',
  'independence',
  'india-united',
  'indinda',
  'indonesia-emas',
  'indubitable',
  'inet-esport',
  'inevitable-loyalty',
  'infalible',
  'infamous-girls',
  'infamous',
  'infernal-gamerz',
  'infernal-void',
  'inferno-gaming',
  'infernogamingr',
  'inferus-esports',
  'inferus-lt',
  'infidels',
  'infinite-talent',
  'infinite',
  'infinity-esport',
  'infinity-esports',
  'infinity',
  'inflames',
  'informmix',
  'infurity',
  'inglorious-gmg',
  'inglorious',
  'iniquity',
  'injury',
  'inner-circle-academy',
  'inner-circle',
  'innercircle',
  'innov8ors',
  'innovate',
  'inox-division',
  'inp-ferrata',
  'inp-valeria',
  'inperpetuumequ',
  'inpower',
  'input',
  'inroads-esports',
  'insaneasylum',
  'insanity',
  'insanium',
  'inshock',
  'inside-games',
  'insiders-esport',
  'insiders',
  'insilio-betboom',
  'insilio-school',
  'insilio',
  'insomnia',
  'insta-baddies',
  'instant-crush',
  'instinct',
  'intact',
  'intech-tenerife-titans',
  'integral-nation',
  'intense-game',
  'intense',
  'interdice',
  'interial',
  'internal-bleed',
  'into-the-beach',
  'into-the-breach',
  'into-the-milk',
  'into-the-rim',
  'intothebarrel',
  'intricate',
  'intz-e-sports',
  'intz-esports',
  'intz',
  'inversion',
  'invicta',
  'invictum',
  'invictus-aquilas',
  'invictus-gaming',
  'invictus-international',
  'invictus',
  'invictusrising',
  'invie-gaming',
  'inward',
  'inz-5',
  'iowa-stormboar',
  'iplay',
  'iq-gaming',
  'ique',
  'ique',
  'ira-draconis',
  'ireland',
  'irie-legacy',
  'irlcs2',
  'iron-blood',
  'iron-branch',
  'iso',
  'istanbul-reaper',
  'istanbul-wildcats',
  'isurus-gaming',
  'isurus',
  'it-doesnt-matter',
  'itaintoveryet',
  'italgo',
  'italian-mix',
  'its-ok',
  'iwku-gaming',
  'iwnl-sweden',
  'iwnl',
  'iwonderchild',
  'ixo-esports',
  'izako-boars',
  'j1l-academy',
  'jack3d',
  'jade',
  'jaguar',
  'jaguares-impetus',
  'jaguares',
  'jahsdnmasjdm-v2',
  'jahsdnmasjdm',
  'jailsmokers',
  'jake-bube',
  'jakebube',
  'jakepaulfanclub',
  'james-bond-bois',
  'janissary-peek',
  'jano',
  'japaleno',
  'jblinky',
  'jehanesburg',
  'jeleel-juice',
  'jelly-jammers',
  'jeremys-au',
  'jerseyboys',
  'jesjakjes',
  'jeste',
  'jft-esports',
  'jft',
  'jijiehao-international',
  'jijiehao',
  'jimmys-m0m',
  'jinkerts',
  'jinseo',
  'jinx',
  'jit-trippin',
  'jits',
  'jjangs',
  'joe-bizon',
  'joebidenesports',
  'joep90g0d',
  'johnny-speeds',
  'join-the-force',
  'jointheforce',
  'jonixal',
  'jons-au',
  'jork-buds',
  'josh-h-fanclub',
  'joueurs-de-pc',
  'jpg',
  'juan-arm',
  'juegalo',
  'juggernauts',
  'jujiin-esports',
  'juked',
  'jumbo',
  'junga',
  'jungle-worms',
  'just-a-glimpse',
  'just-cause-project',
  'just-enough-salt',
  'just-swing',
  'justice-for-tomorrow',
  'justice',
  'juventus',
  'jvac-esports',
  'jynkka',
  'k-hold',
  'k0ht0pa',
  'k0ncept-kuwlaka',
  'k10-fwrd',
  'k10',
  'k1ck-esports-club',
  'k1ck-esports',
  'k1ck-esports',
  'k1ck',
  'k23',
  'k27',
  'kaboom-crocs',
  'kabum!-e-sports',
  'kadlubki',
  'kaffa',
  'kahoot-squad',
  'kajo',
  'kaleido',
  'kalivan-squad',
  'kamkgg',
  'kang-kong',
  'kanga',
  'kaos',
  'kaoz',
  'kappa-bar',
  'kappahorse',
  'karakteamuae',
  'kari',
  'kario-mart',
  'karmageddon',
  'karont3-e-sports-club',
  'katuna',
  'katzwitgunz',
  'kavala-esports',
  'kavenski',
  'kay-team',
  'kazoo-krew-zoo',
  'kda-team',
  'kebab-sultans',
  'kedusexdenuit',
  'keepurselfsafe',
  'kekis',
  'kellyclan',
  'kelnerzy',
  'kennesaw-state-gold-2025',
  'keraunos',
  'kerchnet',
  'keyd-stars-academy',
  'keyd-stars-female',
  'keyd-stars',
  'keyd',
  'kg-network',
  'khai-thonq',
  'khan',
  'kholodtsi',
  'kiki-the-narc',
  'kikifanclub',
  'kill-la-kill',
  'killbox',
  'killerfish-esport',
  'kin2g',
  'kindergarten',
  'kindling-gaming',
  'kinetic',
  'king-of-killers',
  'kingdom',
  'kingsmen',
  'kingsofthenorth',
  'kingzzz',
  'kinky-party',
  'kinship',
  'kira-clan',
  'kiriewki',
  'kiritos-disciples',
  'kitchen-experts',
  'kitsune',
  'kitsuneza',
  'kitten-clan',
  'kkgod',
  'kkkkkkkkkkkkkk',
  'kkona',
  'klaksvik',
  'klan-fontan',
  'klanrur',
  'klaze-clan',
  'klg-lfo',
  'klg',
  'klikexe',
  'klub-sztanga',
  'knight-owls',
  'knownalcoholics',
  'kobe-gaming',
  'kobzenki',
  'kodak-moment',
  'kodatts-kool-kids',
  'kodeone',
  'kogutos',
  'koi',
  'kokodzambo-esports',
  'koksik',
  'kolesie',
  'kolon3',
  'kolossus',
  'kon-finland',
  'kon-norway',
  'kon-sweden',
  'kono',
  'konoha-gaming',
  'kontencja',
  'kooking-esports',
  'koomerz',
  'kopatic',
  'korben-team',
  'kord',
  'kordrengir',
  'kosovo',
  'kova-esports',
  'kova-gaming',
  'kova',
  'koz-getir',
  'kozmosisesports',
  'kpi-gaming',
  'kpi',
  'kpv',
  'kpw',
  'kr-',
  'kraken-seas',
  'kraken',
  'krakenblack',
  'krakenseasgg',
  'krc-genk-esports',
  'krc-genk',
  'krewhl',
  'krisp',
  'kron-klan',
  'kron-talent',
  'kronjylland-main',
  'kronjylland',
  'kronjyllands',
  'krown',
  'krutki-lont',
  'kryptonic',
  'kstraters',
  'kt',
  'ktrl-x-udp',
  'ktrl',
  'kuara',
  'kubix-gaming',
  'kubix',
  'kubixpulse',
  'kuikuilijat',
  'kulun4uk',
  'kunai',
  'kungfukangaroos',
  'kurrupted-mindz',
  'kushtaka',
  'kuuhaku',
  'kuusamo',
  'kuusamo',
  'kuusamogg',
  'kv-mechelen',
  'kviymictokbitib',
  'kyiv',
  'kyivmictokbitib',
  'kynyniekat',
  'kyouasa',
  'kzg',
  'l00kingf0r0rg',
  'l00ped-esports',
  'l2w-esports',
  'la-falconeta',
  'la-glazers',
  'la-lurkers',
  'la-masia',
  'la-pasion',
  'lachampionsliga',
  'lads',
  'lag',
  'laishanhui',
  'laittikola',
  'lajtbitexe',
  'laminatedvcards',
  'lan-bears',
  'lan-party-hotel',
  'lan1t',
  'landodgers',
  'landon-esports',
  'langamers',
  'lanky-smoove',
  'lapatka',
  'lara-zulia-highway',
  'larmo',
  'lasgana-boys',
  'lassos',
  'last-bullet',
  'last-dance',
  'last-minute',
  'lastchance',
  'lastdance',
  'lastdinnerparty',
  'lastpug',
  'lastwind',
  'latetodinner',
  'latifisupremacy',
  'latincowboys',
  'lattenhagen-dso',
  'lausanne-els',
  'lausanne-se',
  'lausanne',
  'lawyers',
  'lax',
  'lays',
  'lazarus-esports',
  'lazarus',
  'lazer-cats',
  'lazercats',
  'lazerrfreeks8',
  'lbs',
  'ldlc-ol',
  'ldlc',
  'ldlc',
  'ldlc',
  'le-club',
  'le-lux-esports',
  'le-lux',
  'leca-fc-aurora',
  'leca-fc-esports',
  'leetcase',
  'leetcaseskin',
  'left-lean-gang',
  'leftout',
  'legacy-esports',
  'legacy-of-aeons',
  'legacy',
  'legam',
  'legends',
  'legion-biack',
  'legion',
  'lego',
  'legopeek',
  'leip',
  'leisure',
  'lemondogs',
  'lenovo-honved',
  'lenovo-legion-honved',
  'lentavat-lehmat',
  'lenzgeneration',
  'leo',
  'leon',
  'lerums-yngre',
  'les-bons-riens',
  'les-bowlcuts',
  'les-frerots',
  'les-sales-babz',
  'lese-esports',
  'lese',
  'lesyklele',
  'let-s-quit',
  'let-her-cook',
  'lethal-divide',
  'lethalcompanycs',
  'lethaldividegg',
  'lets-get-lively',
  'levadia',
  'level-5-rats',
  'level1heroes',
  'levelone',
  'leviatan-academy',
  'leviatan',
  'levitate',
  'levonce',
  'lf0',
  'lfo',
  'lgb-esports',
  'liberals',
  'libertas',
  'liberty-fe',
  'liberty-horizon',
  'liberty',
  'lickin-my-feet',
  'lifealertesport',
  'lifes-a-game',
  'lifted',
  'lighting-bolts',
  'lil-monolith',
  'lilium',
  'lilmix',
  'lilmixgg',
  'limitless',
  'limitlessangels',
  'lindenwood-cs',
  'line5-academy',
  'line5',
  'linx-legacy-vendetta',
  'linx-legacy',
  'linxlegacy-mdgr',
  'lionheart',
  'liquid-biceps',
  'liquid',
  'litan-holo-2014',
  'lite-esc',
  'lithuania',
  'lithuanian-wolves',
  'lithuanianwolfs',
  'little-red-gang',
  'livid',
  'lizard-wizards',
  'll-devil',
  'll-madagaskar',
  'll2-dropouts',
  'llimajlb-gaming',
  'llllllllll',
  'lmaograndaddies',
  'lng-',
  'lng',
  'lnw',
  'loading',
  'lobotomy-gaming',
  'local-c9',
  'locally-hated',
  'locastic',
  'lock-in',
  'lockheeddynamic',
  'loco-smoco',
  'locura-gatos',
  'lodis-ac',
  'lodis-by-illuminar',
  'lodis',
  'lofi-hip-hop-radio',
  'log-esports',
  'logic-gaming',
  'logix-e',
  'lokomelo',
  'london-conspiracy',
  'london-esports',
  'london-lynx',
  'lonely-fans',
  'long-season',
  'longdihacademy',
  'lookinfororg',
  'looking-for-org',
  'looking4beer',
  'looking4org',
  'looking4sponsor',
  'lookingforawper',
  'lookingfororg',
  'loot-goblins',
  'los-3cm',
  'los-albertitos',
  'los-del-ts',
  'los-grandes-academy',
  'los-grandes',
  'los-kogutos',
  'los-matadores',
  'los-pinta',
  'los-pistoleros',
  'los-pollos-herm',
  'los',
  'loscochcoch',
  'loss-and-gain',
  'lost-esports',
  'losthills',
  'lostik',
  'lostrecognition',
  'lotb',
  'loto',
  'lotus-fe',
  'lotus',
  'lounge-gaming',
  'lova-lava',
  'lowbobs',
  'lowkey-pro',
  'lowlandlions',
  'lp',
  'lph-gaming',
  'lph',
  'lps-esports',
  'lpsp',
  'lrv-esports',
  'lrv',
  'lsc',
  'lt-mix',
  'ltd-map-pool',
  'ltd',
  'ltg-esports',
  'lucent',
  'lucid-dream',
  'luciddream',
  'lucky-bas7ard',
  'lukgudplaygud',
  'lukketid',
  'luleflames',
  'lulezi',
  'lumen',
  'lumenvitae',
  'lumina-gaming',
  'luminess',
  'luminosity-gaming',
  'luminosity',
  'lumos',
  'lung-punchers',
  'luriluri',
  'lurker-gaming',
  'lushi',
  'luura',
  'lux-esport',
  'lux-manet',
  'luxe',
  'lv-crocs',
  'lvg',
  'lwcats',
  'lycus-empire',
  'lyngby-vikings',
  'lynn-vision',
  'lynnsanity',
  'lz',
  'm-agents',
  'm0czodol',
  'm0nst3rs',
  'm0nster',
  'm1-eden',
  'm1-team',
  'm1',
  'm16',
  'm19',
  'm1z',
  'm33-x-neimark',
  'm33ac-x-pulsepc',
  'm4-e-sport',
  'm4',
  'm4deyesgamingac',
  'm80',
  'm81',
  'maaskantje-prime',
  'mace-lindu-ruff-rebound',
  'mach-10',
  'mach-5',
  'macherbande',
  'macs-snacks',
  'mad-kings',
  'mad-like-wizards',
  'mad-lions',
  'madagaskar',
  'madanascar',
  'made-in-boston',
  'made-in-brasil',
  'made-in-denmark',
  'made-in-thailand',
  'madjick-gaming',
  'madlikewizards',
  'madvillainy',
  'maelstrom',
  'maestro',
  'mafia',
  'mafu-fan-club',
  'mag',
  'mag10',
  'maggots',
  'magic',
  'magical-eu',
  'magiclight',
  'magicos',
  'magistra',
  'magnats',
  'main-auto-parts',
  'main-gamers',
  'majestic-lions',
  'majesty',
  'majin',
  'makao',
  'make-your-destiny',
  'makeitdifferent',
  'makeshift',
  'makeyousaylate',
  'makia',
  'maknitude',
  'mako',
  'malayindounited',
  'malevolent-ec',
  'malicious-int',
  'malvadinhos',
  'malvinas',
  'mana',
  'manageyself',
  'manansmoneycrew',
  'manatee-esports',
  'mandragora',
  'mangione-family',
  'maniacs-executors',
  'mansionag',
  'mansland',
  'manx-recovery-program',
  'maquinas',
  'marca-registrada',
  'marcaregistrada',
  'mariners',
  'mark-squad',
  'marlian',
  'marpla',
  'marrecos-rising',
  'marrecosgg',
  'marrymescratte',
  'marsborne',
  'marskalk',
  'marsonsonlyfans',
  'marsupialgaming',
  'marsupy-gaming',
  'marten-rising',
  'marten',
  'martians',
  'masked',
  'masked5',
  'masonic-academy',
  'masonic',
  'masq',
  'masquerade',
  'massive-ocean',
  'masso-chiasson',
  'master-club',
  'master-one',
  'mastermind',
  'mastermix123',
  'matlab-demons',
  'matt-arend-g-a',
  'matusmatyssimko',
  'maug-e-sports',
  'mavky',
  'max1muzs-gaming',
  'maxandrelax',
  'maxfloplay',
  'maxima',
  'maxisaucisse',
  'maxxpower',
  'mayak-arena',
  'mayam-gaming',
  'maybe',
  'maybenosplit',
  'maybeprob',
  'maybewin',
  'maycam-evolve',
  'mazaalai',
  'maze',
  'mazraea',
  'mb-university',
  'mb',
  'mc-e-sports',
  'mc',
  'mcon-esports',
  'mcon',
  'mcpork',
  'mcpork2',
  'mcs-gaming',
  'mcs',
  'mdauj',
  'meap',
  'meat-grinders',
  'medellin-cartel',
  'medhelmmilitia',
  'mediagruppen',
  'medieval-riga',
  'medieval',
  'medivate',
  'medusa-',
  'medusa',
  'meepins',
  'meet-your-makers',
  'meetyourdestiny',
  'mega-academy',
  'mega',
  'megahoyla',
  'megamega',
  'megazord',
  'megoshort',
  'meine-arbeit',
  'melac-cyberhack',
  'melb-monkeys',
  'melilla-titans',
  'mellren',
  'melty-esport-club',
  'memo',
  'menace-gg',
  'menszczysni',
  'mental-problem',
  'mentalclear',
  'mentally-ill',
  'mentalmidgets',
  'mentalproblem',
  'mercedesspoiler',
  'mercury',
  'meta-br',
  'meta-brasil',
  'meta-esports',
  'meta-gaming',
  'meta',
  'meta4pro-jr',
  'meta4pro',
  'metanoia-wolves',
  'metanoia',
  'method',
  'method2madness',
  'metins-mangos',
  'metizport-x',
  'metizport',
  'meyvesuyu',
  'mf',
  'mgl-power',
  'mh-elite',
  'miami-flamingos-e-sports',
  'miami-flamingos',
  'miami-pitingos',
  'mibr-academy',
  'mibr-fe',
  'mibr-female',
  'mibr',
  'michael-blackson-uni',
  'michigan-state',
  'michigan-tech-huskies',
  'midasdrakes',
  'middle-age-men',
  'midgard',
  'midland',
  'midnightsociety',
  'midwest-farmers',
  'mielisairaala',
  'might-x-gripgel',
  'might',
  'mightygang',
  'mightywolves',
  'mikesmoneykrew',
  'mikey-mcsnuggles',
  'milk-men',
  'milked',
  'millenium',
  'millennium-ae',
  'millennium-owls',
  'millennium',
  'mind-benders',
  'mind-games',
  'mind-p0wer',
  'mindfreak',
  'mindgamer',
  'mindset-diff',
  'mindtrip',
  'mineski',
  'ministros',
  'minkens-finest',
  'minorities',
  'minsk-house',
  'mirai-gaming',
  'mirai',
  'miraigaming',
  'mirrored',
  'misa',
  'misfire',
  'misfits-gaming',
  'misfits',
  'mishmash-gaming',
  'miss-cs',
  'missing',
  'mission-winnow',
  'mississota-gang',
  'misterya',
  'mix-machine',
  'mix-n623',
  'mix52',
  'mixaajat',
  'mixfits-',
  'mixture9-gaming',
  'mj-peek',
  'mk3-e-sports',
  'mlg',
  'mm-grinders',
  'mna',
  'mo-state-bears',
  'mob',
  'mock-cunchers',
  'mode-weed',
  'modeame',
  'modelotime',
  'models',
  'modern-players',
  'modvind',
  'moes-tavern',
  'mogfia',
  'moggers',
  'mojito-heaven',
  'moke-crethe',
  'moldavian-tiger',
  'mollitiem',
  'molotov-gaming',
  'mommysports',
  'monarch',
  'monaspa-esports',
  'monaspa',
  'money-crew',
  'money-gang',
  'money-hungry',
  'money-men',
  'money-sexual',
  'moniseum-sub',
  'moniseum',
  'monke-push',
  'monkey5-ac',
  'monkeypush',
  'monolith-esports',
  'monolith-gaming',
  'monomaniac-esports',
  'montarzufka',
  'monte-gen',
  'monte-rising',
  'monte',
  'montecarlo',
  'monumentalis',
  'moon',
  'moonday-games',
  'moonlight',
  'moops',
  'moose',
  'moosine',
  'mopped-up',
  'mopse',
  'moralezz',
  'morfanclub',
  'morgon-bats',
  'morning-light',
  'morningstar',
  'moron-5',
  'morrison-boys',
  'mortal-kombat',
  'mortality-esports',
  'mortarcs',
  'moscow-five',
  'mossad-agents',
  'most-hated',
  'mostly-garbage',
  'mostviertelpeek',
  'mouse-accelerators',
  'mouse',
  'mouse4aimers',
  'mousespaz',
  'mousesports',
  'mousquetaires',
  'mouz-nxt',
  'mouz',
  'moviestar-riders',
  'moving-wassi',
  'movistar-riders',
  'mozzymembas',
  'mpoze',
  'mronz',
  'mrvn-esports',
  'mst',
  'msttt',
  'mtp',
  'mtw',
  'mtx-esports',
  'mtx',
  'mudmen',
  'muerta',
  'muffin-miners',
  'muhlige',
  'muhlut',
  'multigraindeath',
  'multivitamin',
  'munanyo',
  'mungy-inc',
  'munich-esports',
  'muscle5',
  'mushyroom',
  'mustang-crew',
  'mustard-tigers',
  'muted-players',
  'muttley-crew',
  'muzhiki',
  'mvd-esports',
  'mvp-cyber-team',
  'mvp-cyber',
  'mvp-iceland',
  'mvp-karnal',
  'mvp-pk',
  'mvp-project',
  'mvp-space',
  'mvp',
  'mxa',
  'mxm-s',
  'mxm',
  'mxtm',
  'my-life-be-like',
  'mybad',
  'mydgb',
  'mygame',
  'myhud',
  'myinsanity-swiss',
  'myinsanity',
  'myllyn-paras',
  'myllysuola',
  'mynec',
  'myskill',
  'mysordps',
  'myth-e-sports',
  'myth-esports',
  'myth',
  'mythic',
  'mythicc',
  'mythlock',
  'myxmg',
  'myztro-gaming',
  'mzp',
  'n!faculty',
  'n-w-g',
  'n-z-w-a',
  'n00rg-cs',
  'n0mads',
  'n1ght-esports',
  'n20',
  'n2e',
  'n3far1ous',
  'na-dream-team',
  'na-fascie',
  'na-last-hope',
  'naapurit',
  'nade-brigade',
  'nadiya',
  'nalakuvara',
  'nameless',
  'nandian-nation',
  'nani-e-sports',
  'nao-tem-como',
  'napalm-energy',
  'napt',
  'narcis',
  'narukami',
  'nas-best-bots',
  'nas-last-hope',
  'nas',
  'nashville-peek',
  'nasr-esports',
  'nasr',
  'nasty',
  'nastymittens',
  'natesmile',
  'national-cs-uni',
  'native-2-empire',
  'native',
  'natus-catcere',
  'natus-vincere-junior',
  'natus-vincere',
  'navi-javelins',
  'navi-jr',
  'navi-junior',
  'navi-youth',
  'navi',
  'navi',
  'nazar-eye',
  'ncsu',
  'nctdk',
  'ndawoods',
  'nebula',
  'nebulaesportspt',
  'necromancer',
  'neds',
  'need1-agency',
  'needdoctor',
  'needmorecash',
  'needone-agency',
  'nefour',
  'nekfat-tactics',
  'nekoma',
  'nekst',
  'nemesis',
  'nemiga-gaming',
  'nemiga',
  'neon-lights',
  'neophyte',
  'neptune-esports',
  'neptune',
  'nerdrage',
  'netcode-illuminati',
  'netcodeguides',
  'netcodeguidesdotcom',
  'netctrlv',
  'netherlands',
  'neu-gold',
  'neurotic-gold',
  'never-ever',
  'never-hate',
  'never-named',
  'never-paid',
  'never-say-never',
  'never5-esport',
  'neverest',
  'nevermind',
  'neverplay',
  'new-england-whalers',
  'new-happy',
  'new-legends',
  'new-pampas',
  'new-quali-team',
  'new-threat',
  'new-vision',
  'new4',
  'new4ge-esports',
  'neway',
  'newballs',
  'newbelarus',
  'newborn',
  'newd',
  'newera',
  'newgen-esports',
  'newgeneration',
  'newhappy',
  'newport-factory',
  'newps',
  'newvalors',
  'nexga',
  'nexium-polteam',
  'next-in-line-esports',
  'next-up',
  'nextg',
  'nextlevel-es',
  'nextplease!',
  'nextup',
  'nexus-academy',
  'nexus-gamers-pub',
  'nexus-gaming',
  'nexus',
  'nexusac',
  'nexuz',
  'nexvoid',
  'nezumi',
  'ng',
  'ngh',
  'ngse',
  'nibble-haze',
  'nibble-kenko',
  'nic',
  'nice-try',
  'nicecactus',
  'night-gaming',
  'nightmare-esp',
  'nightmare-esports',
  'nightwatch',
  'nigma-galaxy-fe',
  'nigma-galaxy',
  'nihilum-gaming',
  'nii-kerge',
  'niisesports',
  'nikakix',
  'nine2five',
  'ninefly-esports',
  'ninefly',
  'nineshapes',
  'ninguem-ta-puro',
  'ninj-gg',
  'ninja',
  'ninjabreadz',
  'ninjaparentz',
  'ninjas-in-boxer',
  'ninjas-in-pyjamas',
  'nip-impact',
  'nip',
  'niskalaukaus',
  'nitro',
  'nitrogg',
  'nixuh',
  'nixuhgg',
  'njl0thblu-kek',
  'nkbasketweavers',
  'nkt',
  'nku-gold',
  'nme',
  'nnayas-tsuki',
  'nnayas',
  'no-bystanders',
  'no-ceilings',
  'no-chot',
  'no-face-no-case',
  'no-idea',
  'no-kit',
  'no-limit-gaming',
  'no-limit',
  'no-love',
  'no-name',
  'no-namers',
  'no-problem!',
  'no-problem',
  'no-quarter-cartel',
  'no-respect',
  'no-shot',
  'no-sir!',
  'no-tenemos-nada',
  'no7eam',
  'noa',
  'noble-esports',
  'noble',
  'nobo',
  'nobraindrypeek',
  'noc-kruka',
  'nocco-dusty',
  'nochance',
  'noctis-bellator',
  'nocturnal',
  'nocturns',
  'noctus-esports',
  'noface-gaming',
  'nofear5',
  'nogym-esports',
  'noir-verse',
  'noire',
  'nokevlarreq',
  'nolightgaming',
  'nolimitskill',
  'nom-esports',
  'nom',
  'nomadic-tactics',
  'nomads',
  'nomatter-',
  'nomercy',
  'nomral',
  'nonaimers',
  'noname',
  'nonamers',
  'nonameteam',
  'nonnih',
  'noob-esports',
  'noobindisguise',
  'noobz',
  'nopression',
  'nopullouts',
  'nordavind-talent',
  'nordavind',
  'norden',
  'nordic-partners',
  'nordix-esport',
  'nordix',
  'noreason-gaming',
  'norsera',
  'north-academy',
  'north-macedonia',
  'north-royal',
  'north',
  'northern-forces',
  'northern-legacy',
  'northern-lights',
  'northern-star',
  'northwest',
  'noscape',
  'nosens',
  'nostalgia',
  'nosurrendergg',
  'not-a-squad',
  'not-my-entry',
  'not-my-igl',
  'not-so-team',
  'notachance',
  'noteg1',
  'notg4yiswear',
  'notolerance',
  'nouns-fe',
  'nouns',
  'nova-aetas',
  'nova-gaming',
  'novair',
  'novaq',
  'novax',
  'novum',
  'nowheretorun',
  'nox-gaming',
  'noxa-gaming',
  'noxious',
  'nrg-esports',
  'nrg',
  'nsjj-reborn',
  'nsn',
  'nspr-gaming',
  'nt-try',
  'ntk',
  'ntox',
  'nubile-gamers',
  'nubo',
  'nuclear-tigeres',
  'nujabes',
  'nut-academy',
  'nut-e',
  'nutorious-skewl',
  'nutorious',
  'nutoriouseu',
  'nutriaesports',
  'nvdd-em-breve',
  'nyx-empyre',
  'nyx-peek',
  'nyxon',
  'nyyrikki-esports',
  'nyyrikki',
  'nz-gaming',
  'o-block-esports',
  'o-plano-',
  'o-plano-b',
  'o-plano',
  'o2-peek',
  'oasis-gaming',
  'oblivion',
  'obscure-club',
  'ocb-gg',
  'ocb-nxt',
  'ocbgg',
  'ocean-fire',
  'ocean-gaming',
  'oceanus',
  'oddik-ac',
  'oddik-academy',
  'oddik',
  'odium',
  'odjur',
  'odra-wodzislaw',
  'odyssey-gaming',
  'odyssey',
  'oe-esports',
  'off-balance-gaming',
  'off-the-air',
  'off-the-grid',
  'offbalance',
  'officers',
  'offset-esports',
  'offset',
  'offspring',
  'og-academy',
  'og-hhe',
  'og',
  'oghood',
  'ogzxcgbc-x-worldwide',
  'oh-gaming',
  'oh-yeah-gaming',
  'ohhnoooo',
  'ohio-meat-wagon',
  'oilers-esport',
  'oilers',
  'ok2strong',
  'okay-synergy',
  'okedan-100',
  'oksucc',
  'okt',
  'old-boys-club',
  'old-dads-banging',
  'old-dogs',
  'old-gods',
  'old-gold',
  'old-guys-club',
  'old-kings',
  'old-man-gang',
  'old-meta',
  'old-mofos',
  'oldboys-pl',
  'oldbutgold',
  'olddirtybastard',
  'oldfartfraggers',
  'oldfriendsclub',
  'oldnotobsolete',
  'oleron-gaming',
  'olgodefterskole',
  'olmpq',
  'olybet',
  'olympus',
  'omega',
  'omen-1800-gang',
  'omen-dingtone',
  'omen-dynasty',
  'omen-esports',
  'omen-nyx',
  'omen-reapers',
  'omen-slorpers',
  'omen-upsetti',
  'omen',
  'ominous-esports',
  'omni-gaming',
  'omni5',
  'omnius',
  'on-disability',
  'on-some-bs',
  'on-the-money',
  'on0n99',
  'onamo',
  'once-divine',
  'ondskan',
  'one-last-ride',
  'one-one-esport',
  'one-tap',
  'one',
  'onet4p',
  'onetap',
  'onethree',
  'oni',
  'onlinebots',
  'onlinekings',
  'onliners',
  'only-one-word',
  'only-positive',
  'onlybeaugosse',
  'onlyfans-v2',
  'onlyfans',
  'onlyfrags',
  'onlytoms',
  'onslaught',
  'onyx-dojo',
  'onyx-ravens',
  'onyx-talents',
  'onyx',
  'oof-reborn',
  'ooga-booga-es',
  'oolaroo-esports',
  'opaa',
  'opengamers',
  'opera-gx-phantoms',
  'operation-doom',
  'operation-kino',
  'opium',
  'oplano-academy',
  'opp-goblins',
  'optic-gaming',
  'optic-india',
  'opyt',
  'oracle-esport',
  'oramond',
  'orange-esports',
  'orbital-vsat-online',
  'orca',
  'order-zero',
  'order',
  'orgless-5',
  'orgless',
  'orion-esports',
  'orion-oldsters',
  'orion',
  'orionyoungsters',
  'orlando-outlaws',
  'oro-gg',
  'oro',
  'os-catioros',
  'osadia',
  'osama-bin-fraggin-reborn',
  'osama-gaming',
  'oshikousei',
  'oslo-lions',
  'otg',
  'otherscantbeat',
  'outfit-49',
  'outgoingesports',
  'outlast-black',
  'outlast',
  'outplayed',
  'outreach-tech',
  'outsiders',
  'ovacion-esports',
  'over-your-head',
  'overfrag-yng',
  'overfrag',
  'overgaming',
  'overknight',
  'overpeek',
  'overperformers',
  'overrated',
  'overt',
  'overtake-sector',
  'overtake',
  'ovg-rising',
  'ovg',
  'ovoxo',
  'owl',
  'oxalyde',
  'oxingame-esport',
  'oxingame',
  'oxuji-mint',
  'oxuji',
  'oxygene',
  'ozempic-5',
  'p0db0tz',
  'p1p',
  'paaarful',
  'pablow-escobar',
  'pacama',
  'paceka',
  'pacos-tacos-2',
  'pact',
  'padaemholodnie',
  'padding-egos',
  'pain-ac',
  'pain-academy',
  'pain-gaming',
  'pain',
  'pais-solteiros',
  'pajuris',
  'palladium',
  'paloma',
  'panda-gaming',
  'pandaric-aces',
  'pandaricesports',
  'pandemoniumgg',
  'panica-gaming',
  'panicattheveto',
  'pant-gang',
  'panter-esports',
  'panthers-gaming',
  'panthers-never-surrend',
  'panthers-never-surrender',
  'panthers',
  'pantsu',
  'papa-bust',
  'paperclip',
  'paperplanes',
  'paqueta',
  'parabellum-fe',
  'paradox-academy',
  'paradox-gaming',
  'paradox',
  'parallax',
  'paranoia-esports',
  'parivision',
  'part-timers',
  'partizan-junior',
  'partizan-red',
  'partizan',
  'partizanesports',
  'parttime-ninjas',
  'party-astronauts',
  'party-daddler',
  'party-daddlers',
  'partydaddlers',
  'pasha-camp',
  'passion-academy',
  'passion-ua',
  'passions',
  'past-our-prime',
  'patatipatata',
  'patinc-patlanc',
  'patins-da-ferrari',
  'patinsd-ferrari',
  'pats-money-crew',
  'paw-patrol',
  'pawer-kambak',
  'pawermoob',
  'pbs-money-crew',
  'pbyty3',
  'pc419',
  'pcific-espor',
  'pcific',
  'pcs-academie',
  'pcs',
  'pdhm',
  'pe69ta',
  'peace-ducky4',
  'peacegaming',
  'peak',
  'pecorino-cs',
  'pee-shooters',
  'peeker-s-advantage',
  'peekers-adv',
  'peekers-advantage',
  'peeking-washed',
  'peep',
  'peeweeeats',
  'pel0nalities',
  'pelia',
  'peltisissiparvi',
  'penazoid',
  'penchod-peakers',
  'penguin-logis',
  'penjamain',
  'pensionatet',
  'penta-infusion',
  'penta-sports',
  'penta',
  'pentagram-g-shock',
  'peons',
  'pepeepa-peek',
  'pera',
  'perfect-storm',
  'perfectsymphony',
  'perfectworld',
  'permitta-ac',
  'permitta-academy',
  'permitta-ua',
  'permitta-w',
  'permitta',
  'peronus-longus',
  'perplexed',
  'perplexity',
  'persona-esports',
  'persona-grata',
  'pesadilla',
  'pesatdva',
  'pesujakuivaus60',
  'pew-pew-pandas',
  'pewnoscsiebie',
  'pewpew-vikings',
  'pge-turow-zgorzelec',
  'pge-turow',
  'ph-enthusiasts',
  'phantom-academy',
  'phantom-esports',
  'phantom-sense',
  'phantom',
  'phantoms',
  'phase-team',
  'phase3',
  'phil-collins',
  'philadelphia-liberty',
  'phoenix',
  'photographers',
  'phx-cs2',
  'phyre-gaming',
  'physics-fanclub',
  'pichau',
  'pick-and-split',
  'pig-gaming',
  'pigeons',
  'pigsty',
  'pikku-pupu',
  'pirates-esports',
  'piss-gem-gamin',
  'piss',
  'pisyatdva',
  'pitchu-gang',
  'pitsuytvosem',
  'pitt-haircuts',
  'pivot',
  'pivstar',
  'pixelfire-gaming',
  'pixlip',
  'pl123',
  'placeduvillage',
  'placeholder',
  'plague',
  'plan-b',
  'planet-express',
  'planetkey-dynamics',
  'planetoftheapes',
  'planetofthegape',
  'plasma-vitaplur-gum',
  'plasma-vitaplur',
  'platinium-esport',
  'platoon-alpha',
  'platoon-beta',
  'platoon',
  'playart',
  'players',
  'playfire',
  'playing-ducks',
  'playing-for-fun',
  'playit',
  'pleingaz',
  'plink-tech',
  'plitkach0',
  'plmix',
  'plnetkey-dynamics',
  'plus-w',
  'plush',
  'plusw',
  'pmperfect',
  'pnda-gaming',
  'pneuma',
  'poceblo',
  'pocomaxa',
  'podredbulom',
  'podstol-gaming',
  'poggerz',
  'poggies',
  'pogov3',
  'poisonous-bunny',
  'pokemon-go',
  'pokemon',
  'pokemons',
  'poker',
  'poland',
  'polar-ace-esports',
  'polar-ace',
  'polet',
  'poligon',
  'polish-cuddlers',
  'polska-gurom',
  'polteam',
  'pome-jazda',
  'pomme-do-aca',
  'pompa-team',
  'pompa',
  'poohank',
  'por',
  'poranaprzygode',
  'porcine-command',
  'pork',
  'portal-esport',
  'poseidon',
  'pot-bellies',
  'potential-to-stack-dough',
  'pottery',
  'poundland',
  'povydlo-esports',
  'power-clickers',
  'power-gaming',
  'power-rangers',
  'powerfinesse',
  'powermode',
  'pozdrowienia-dla-piwa',
  'pr-01',
  'pr-stars',
  'pr1med-esports',
  'prague-lions',
  'prasso-clan',
  'prasso',
  'pray-gaming',
  'preasy-rising',
  'preasy',
  'predvlotl',
  'prem-ghoulsiwnl',
  'premghouls',
  'press-mouse1',
  'press-z',
  'prestige-ec',
  'prestige-esport',
  'prestige',
  'prevail-anz',
  'pride-gaming',
  'pride',
  'pries',
  'prifu',
  'prilyot',
  'prima-esport',
  'prima-t',
  'prima',
  'primal-is-fat',
  'prime-bulls',
  'prime-delivery',
  'princesses',
  'priority-black',
  'priority-gamma',
  'priority-hollow',
  'priority-ice',
  'priority-kage',
  'priority-nexus',
  'priority-red',
  'priority-thrash',
  'priority-vnd',
  'priority',
  'priorityacademy',
  'prism',
  'prisonbreak',
  'private',
  'privateer',
  'prizepicks-employees',
  'prizivanet',
  'prizyvanet',
  'pro-by-40',
  'pro-goofballs',
  'pro-lapse',
  'pro-nounz',
  'pro-state-kings',
  'pro100',
  'problematic',
  'problosingsleep',
  'procamp-ua',
  'procyon',
  'prodigiessweden',
  'prodigy',
  'progaming-esports',
  'progaming',
  'proj-hail-mary',
  'project-1',
  'project-24',
  'project-91',
  'project-conquerors',
  'project-eversio',
  'project-h1',
  'project-hw',
  'project-susanoo',
  'project-telstar',
  'project-west',
  'project-x',
  'project-z-theta-x',
  'project8',
  'projectfidelity',
  'projectless',
  'projectx',
  'projet-bluebeam',
  'projetodokingui',
  'prone',
  'property',
  'proqsmoneycrew',
  'prospects',
  'prototype-blaze',
  'provality',
  'prowince',
  'proximity-uk',
  'prs-gaming',
  'pryde',
  'psiaku',
  'pstream-pirates',
  'psycho-squad',
  'psychok1ds',
  'psymonsitmom',
  'pte-peac',
  'ptitscostauds',
  'pts-e-sports',
  'public-enemy',
  'publiclir',
  'pucks-deep',
  'pufflepals',
  'puggersinparis',
  'puggin4fun',
  'puggin4seb',
  'pugging4pumpkin',
  'puggywuggy',
  'pugiles',
  'pugstarmagnates',
  'pugstars',
  'puhevika',
  'pulse-gaming',
  'pulse',
  'punjabi-pirates',
  'pure',
  'pureskillggblu',
  'puscasii-marini',
  'pushin-pweice',
  'pv-rap-g0dzzz',
  'pvntsu',
  'pvo',
  'pwrgum-red',
  'pyypaisti',
  'qck-gaming',
  'qinorhwat',
  'qlash',
  'qlimax',
  'qmistry-rising',
  'qmistry',
  'qtuquerestamole',
  'qu-de-ma',
  'qual4-lfo',
  'qual4',
  'quality',
  'quantic-gaming',
  'quanticleverage',
  'quantum-bellator-fire',
  'quantum-farts',
  'quantum-flames',
  'quantum-prodigy',
  'quantumsyngergy',
  'quantumteam',
  'quantumx',
  'quazar-2',
  'quazar-nsk',
  'quazar-x-44',
  'quazar',
  'quazar',
  'quazarplayers',
  'queefers',
  'queenconso',
  'quem-sao-elas',
  'queso',
  'quest',
  'questionmark-',
  'questionmark',
  'quick-munch',
  'quickplay-grey',
  'quiet-down',
  'quinque',
  'quintessence',
  'quitgoats',
  'quixal',
  'qupmanacs',
  'qvg-academy',
  'qvg-esports',
  'r-neck',
  'r2',
  'r3action',
  'r3m3mb3r',
  'r4g-oldsql',
  'r4g-ruby',
  'r6-to-cs',
  'rabbit',
  'raccoons',
  'racing',
  'rad140-abusers',
  'radiantkeysus',
  'radix-esports',
  'radix',
  'raelix-esport',
  'rage-quit',
  'raggie-aimers',
  'raging-unicorns',
  'raiders',
  'raido',
  'raijin',
  'rajutkundit',
  'randys-waifus',
  'rapidunity5',
  'raptors-ec',
  'rare-atom',
  'raslattgaming',
  'rat-gang',
  'rat-pack',
  'ratajkowski-fc',
  'ratel-squadron',
  'ratkiller',
  'rattlesnakes',
  'ravagers',
  'rave',
  'ravens-jp',
  'ravens',
  'rawkus-cawkus',
  'razed-esports',
  'razed',
  'rbg-esports',
  'rbg',
  'rcave',
  'rctic-esports',
  're-di',
  'reachperfection',
  'read-you-like-a-kindle',
  'real-esports',
  'real-hustle-club',
  'real-winner-company',
  'realistic',
  'reality-check',
  'realmadrid',
  'realwunz',
  'reason-gaming',
  'reason-gaming',
  'reason',
  'reasongaming',
  'rebel-stars',
  'rebels',
  'rebirth-clan',
  'rebirth',
  'recca-esports',
  'reckoning',
  'recognised-talent',
  'recon-5-black',
  'recon-5',
  'rectify',
  'recursive-esports',
  'red-ball-market-global',
  'red-canids-academy',
  'red-canids',
  'red-feet',
  'red-flaggg',
  'red-instinct',
  'red-reserve',
  'red-sun-in-sky',
  'red',
  'redacted',
  'redactedsociety',
  'redemption-esports-poa',
  'redemption-esports-porto-alegre',
  'redemption-poa',
  'rederebel',
  'redfear',
  'redgg',
  'redhood',
  'redline-esports',
  'redliners',
  'redpack-esports',
  'redpack-quantum',
  'redpack',
  'redragen',
  'redragon-academy',
  'redragon-fe',
  'redragon',
  'redtigersgaming',
  'redtyfguhoj',
  'redux',
  'reece',
  'reflex-e-sport',
  'reflexx',
  'reform',
  'reformed-gamers',
  'regain',
  'regnum4games-ac',
  'regnum4games',
  'rehl',
  'reign-above',
  'reign',
  'rejected-by-all',
  'rejectsv2',
  'rejexesports',
  'relegated-arnes',
  'relic',
  'rem',
  'remnant',
  'remorselesswntr',
  'renegades',
  'renewal',
  'rent-is-due',
  'rentner',
  'report-massive',
  'res-gaming',
  'reserve',
  'resilience5',
  'resilient',
  'resolute',
  'resurgence',
  'resurgencecsgo',
  'rethink',
  'retired-aimers',
  'retired-demons',
  'retired5',
  'retirement-home',
  'retirementhome',
  'retony',
  'retrograde',
  'retrowv-academy',
  'reunion',
  'reveal-academy',
  'reveal-tactx',
  'reveal',
  'revel',
  'revelations-cs',
  'revelationscs',
  'revenge-nation',
  'revenge',
  'revise',
  'revitalize',
  'revival-gaming',
  'revolt-w-united',
  'revolution',
  'rewound',
  'rexo-gaming',
  'rey-esports',
  'rezist',
  'rgw-esports',
  'rhein-neckar',
  'rheinkirmes',
  'rhyno-esports',
  'rhyno-youngsters',
  'rhyno',
  'rice-nation',
  'ricochet',
  'riot-squad',
  'ripnstick',
  'riprising-gaming',
  'riptide-ogs',
  'rise-nation',
  'rise',
  'riseup-esport',
  'risin',
  'rising-stars',
  'risky-business',
  'risky-gaming',
  'river-plate',
  'river',
  'rizon',
  'rizondotgg',
  'roa-esports',
  'roa-main',
  'road-to-gold',
  'road2kato2034',
  'roadtotokyo',
  'roar-esports',
  'robus-tu-sinqn',
  'roc-team',
  'rocean-academy',
  'rocean',
  'rocket',
  'roflnation',
  'rogue',
  'rogysanimeteam',
  'rokiskio-elitas',
  'rolling-circus',
  'rollout-esports',
  'roman-chimpire',
  'romania',
  'ronin',
  'ronins',
  'room-service',
  'room-temp-iqs',
  'rooster-fury',
  'rooster',
  'roots-gaming',
  'roots',
  'rosomaha',
  'rot',
  'rotacak',
  'rounds',
  'roundsgg',
  'roundsunity',
  'royal-bandits',
  'royal-republic',
  'royalerrambo',
  'royals-academy',
  'royals-uk',
  'royals',
  'royalty',
  'rpi-cs',
  'rtsports',
  'rtu-mirea',
  'ruby',
  'rude',
  'rufus',
  'rugratz',
  'run-or-die',
  'runaway',
  'rune-eaters',
  'rungun',
  'runthedamnball',
  'rur-esports',
  'rush-b',
  'rush',
  'rush3d',
  'russian-men',
  'rustec',
  'ruvious',
  'rvg-blacktrains',
  'rvns',
  'rysix-gaming',
  'ryvex',
  'rzabka',
  's-a-c-k-e-r-s',
  's-a-d-b-o-y-s',
  's-gaming',
  's-monks',
  's2v',
  's3xtremum',
  's8-x-soulgame',
  'sabiii',
  'sabotage',
  'sacramento',
  'sad-genius',
  'safir',
  'saga',
  'sahangiller',
  'saidera',
  'saint-sinners',
  'saints',
  'saja-boys',
  'sajanex-esports',
  'sakana123',
  'sakura',
  'salamander',
  'salem-catfish',
  'saltcrew',
  'samantha3',
  'same-5-guys',
  'sampi-next',
  'sampi-tipsport',
  'sampi',
  'sampo',
  'samurai-legends',
  'samurai',
  'san-marino-team',
  'sangal-1xalters',
  'sangal-academy',
  'sangal',
  'sanguine',
  'santos-dexterity',
  'santos-e-sports',
  'santos',
  'sao-caetano',
  'sapper-academy',
  'sapper',
  'sashi-academy',
  'sashi-esport',
  'sashi',
  'sassy-sunshines',
  'saturlity',
  'saturlityesport',
  'saucemen',
  'savage',
  'save-s',
  'savi-esports',
  'saw-youngsters',
  'saw',
  'sawo',
  'sayonara',
  'sb-gaming',
  'sc-e-sports',
  'sc-esports',
  'scallops',
  'scarx',
  'scarybears',
  'scbh',
  'schadenfreude',
  'scmf-esports',
  'scorp',
  'scream4mongolia',
  'scrimless',
  'scrub-daddy',
  'scuba',
  'scubatuba',
  'sd-gaming',
  'sd-invicta',
  'sdu',
  'se7en-esports',
  'seafood-delight',
  'seal-team-5',
  'sealions',
  'secomportaya',
  'second-nature',
  'secondcs2',
  'secret-sisters',
  'secret',
  'sector-one',
  'sedated',
  'seirin',
  'seize',
  'seizures-palace',
  'sekasorto',
  'selecadobt',
  'selectah',
  'selected-five',
  'selfish-pricks',
  'selfless-gaming',
  'semper-fidelis',
  'semperfi',
  'semxorah',
  'sen-mouz',
  'seneos',
  'sensei-la-dews',
  'senshi-bnl',
  'senshi-esports',
  'sensoria-esport',
  'sentora-saints',
  'sentora',
  'senz-esports',
  'seoul',
  'sequel',
  'sera-esport-swe',
  'sera-esportal',
  'sera-esports-dk',
  'sera-esports',
  'sera',
  'serbia',
  'serenity-ec',
  'serenity-gg',
  'serenityesports',
  'serpent-gaming',
  'sestri',
  'seven-wars-e-sports',
  'seven',
  'sevenizi',
  'sever14-team',
  'severe',
  'sfd-academy',
  'sfdevastadores',
  'sfto-esports',
  'sg-e-sports',
  'sg',
  'sgo-de-oro-v2',
  'sgpro-paradise',
  'sh1zieepeek',
  'shaboing-boing-bandits',
  'shades',
  'shadow-wizard-money-gang',
  'shadowcore',
  'shadows',
  'shaman',
  'shaolin-esports',
  'shape',
  'shapito-',
  'shaq-diesel',
  'sharks-esports',
  'sharks-yngs',
  'sharks',
  'sharp',
  'shed',
  'sheremetjevo',
  'shika',
  'shikubi',
  'shimmer-',
  'shimmer',
  'shinden',
  'shinzoabefc',
  'shipachi-team',
  'shipachi',
  'shirtcockin',
  'shiznays',
  'shpl',
  'shreeesports',
  'shtraus',
  'shufu',
  'shwiftyy',
  'si9dan',
  'sicarios',
  'side-peek',
  'sidequest',
  'sigmaboysnunc',
  'sigmatix',
  'signature-gaming',
  'signatus',
  'signum-esports',
  'sikaniska',
  'silapersila',
  'silencers-',
  'silencers',
  'silent-aim',
  'silentgaming',
  'silly-strikers',
  'sillycs',
  'silvercrows',
  'simmer-ume',
  'simplicity',
  'sin-muerto',
  'sin',
  'sine-solis',
  'singularity-esports',
  'singularity-female',
  'singularity',
  'sinister',
  'sinister5',
  'sinkin-ship',
  'sinners-academy',
  'sinners-esports',
  'sinners-gaming',
  'sinners',
  'sinqu-rehti',
  'sinqu',
  'sinsi-atak',
  'sissi-state-punks',
  'sistersonsalary',
  'sisyphus-gaming',
  'sitis-victoria',
  'sivasspor-espor',
  'sixbanners',
  'sixsevenzaza',
  'sj-gaming',
  'sj',
  'sk-gaming',
  'skade-x',
  'skade',
  'skdc',
  'skebob',
  'skeeb-clan',
  'skele',
  'skeptical',
  'skiberesbiberes',
  'skibidigaming',
  'skillstars-pro',
  'skillzone',
  'skinchies',
  'skitlite-gaming',
  'skitlite',
  'skmc',
  'skuak',
  'skull-butcher',
  'skull-cracker',
  'skulls-crew',
  'sky-wanderer',
  'skyblades',
  'skyfire',
  'skyfury',
  'slake',
  'slashlevel',
  'slavonpc',
  'slay',
  'sleepers',
  'sleeping-dogs',
  'sleepless-gaming',
  'sleepy-shooters',
  'slice-a-ham',
  'slick',
  'slime-gang',
  'slimy-boogermen',
  'slnt-procloud',
  'slnt',
  'sloppy-floppy',
  'slovakia',
  'slp',
  'smakolysze',
  'small-rejuice',
  'smalsiai',
  'smart-faqs',
  'smartcarpeek',
  'smash',
  'smeshariki',
  'smile-and-wave',
  'smile',
  'smiles',
  'smiss-b-team',
  'smiss',
  'smoke-fe',
  'smoke-gaming',
  'smoke-tram',
  'smokepoint',
  'smooth-brains',
  'smuuttikusilkki',
  'sn-comets',
  'snack-club',
  'snake-eyes',
  'snakes-den',
  'sneak-nade-prac',
  'snogard-dragons',
  'snorkel',
  'snowpards',
  'snowpardsviolet',
  'snowplowers',
  'snussyesports',
  'soar-gaming',
  'soarin-n-fourin',
  'soberano-team',
  'socialangstuwu',
  'socks-sniff',
  'soerkkae',
  'softcarefoam',
  'softshaft',
  'sojoga-academy',
  'sojoga',
  'sojuu',
  'sola-gaming-red',
  'sola-gaming',
  'sola',
  'solace',
  'solaris-esports',
  'solarity-esports',
  'solid-ice',
  'solid',
  'soloq-gaming',
  'solove',
  'somalians',
  'something-funny',
  'something',
  'son-esports',
  'son-northwinds',
  'sons-of-lennart',
  'sonylandiacones',
  'sopgubbarna',
  'soprano-cwell',
  'sorby-flames',
  'sotano',
  'sotanogamer',
  'souldazz',
  'soulfrost-ac',
  'soulfrost-esports',
  'souls-heart',
  'souls-land',
  'soulseekers',
  'soulsheart',
  'sound-of-arthritis',
  'sourdoughbros',
  'south',
  'southampton',
  'southern-blend',
  'southern-scam',
  'southern5',
  'sovereign',
  'soyboysxp',
  'sp1ria',
  'sp8-',
  'space-force',
  'space-jam',
  'space-monkeys',
  'space-soldiers',
  'space-station',
  'space',
  'spaced-0ut',
  'spaceshoobs',
  'spacestation-gaming',
  'spade-gaming',
  'spain',
  'spanner5',
  'sparta',
  'spartans-eu',
  'sparx',
  'spate-esports',
  'spaztic',
  'spec-eds',
  'special-boys',
  'specter-esports',
  'specter-tavius',
  'spectre',
  'spectrum',
  'speedhun72rz',
  'speedlink',
  'spicy-bois',
  'spicyerbois',
  'spiffy',
  'spin-da-block',
  'spirit-a-black',
  'spirit-academy',
  'spirit-esports',
  'spirit-fe',
  'spirit-female',
  'spirit-hu',
  'spirit-of-amiga',
  'spirit',
  'split-esc',
  'sploinky-wid-it',
  'splyce',
  'sponsored-by',
  'spooky-squad',
  'sportsbetexpert',
  'spot-up',
  'sprawgs',
  'spray-jutsu',
  'springfield',
  'sprout',
  'sqkte-hai',
  'squad-of-lions',
  'squad',
  'squadra-azzura',
  'squadup',
  'square-feet',
  'squared-esports',
  'squared-prospects',
  'squeegee',
  'squirt-squad',
  'squishysangels',
  'srplgang',
  'sskt',
  'ssp-main',
  'sspcs2',
  'st-cote-de-porc',
  'stabaek-momentum',
  'standing-dudeside',
  'standonbusiness',
  'staqued',
  'star-childs',
  'stargazinge',
  'stars-horizon',
  'stars-of-europe',
  'state',
  'station-7',
  'stay-frosty',
  'staymadhoes',
  'steel-helmet',
  'stellar',
  'stfdysab',
  'sthlm-city',
  'stillmain',
  'stinc-team',
  'stmn',
  'stoic-inter',
  'stompgods',
  'stone',
  'stoneck',
  'stop-the-spiral',
  'storm-rider',
  'storm-wolves',
  'storms-bait-shop',
  'stormuzb',
  'stormzz-',
  'strael-bora',
  'strafe-cru',
  'strafe',
  'straight-gas',
  'straight2killin',
  'straightoutfire',
  'strawberry-poptarts',
  'strawhats',
  'straykids',
  'street-dogs',
  'strife',
  'strive-in-chaos',
  'stronghold',
  'struggletony',
  'stunnass',
  'stunted-and-old',
  'stuzoo',
  'sub-21',
  'subnormals',
  'subutai',
  'subway-surfer',
  'subzero-esports',
  'succ-n-fucc',
  'suck-brick-kid',
  'suerte-quantica-reborn',
  'sugmaidry',
  'suicide-squids',
  'sumakthesenuts',
  'summa',
  'summit',
  'sunburn',
  'sunnuntai',
  'sunny-meadows',
  'sunshineliquors',
  'sunthraw',
  'super-phalanx',
  'super-pigeon',
  'super-shy',
  'super-zawodnicy',
  'superioresports',
  'superjymy',
  'supermassiveac',
  'supernova-comets',
  'supernova-cs',
  'supernova',
  'supersangrejoven',
  'supersoakerclub',
  'supertroll',
  'supremacy',
  'surfers',
  'surge-esports-club',
  'surprisev2',
  'surreal',
  'sussy-reloaded',
  'suxen',
  'swaglord3000',
  'swagmonkeyhats',
  'swamp-monsters',
  'swampass',
  'sway-esports',
  'sweden',
  'swedesnsandhals',
  'sweet-angels',
  'sweild',
  'swiftgamers',
  'swing-or-be-swung',
  'swing9',
  'swingers',
  'swmdm',
  'swole-patrol',
  'sws-gaming',
  'sws',
  'sybau',
  'syf-gaming',
  'syfgaming',
  'sylyx',
  'syman-gaming',
  'syman',
  'symbiose',
  'symbiosis',
  'sympletech',
  'synapse',
  'synchronicity',
  'synck',
  'synergy-esports',
  'synergy',
  'synical',
  'synrgy-gaming',
  'syntagma',
  'synthetic',
  'sz-absolute',
  'szeregowcy',
  't-hamsters',
  't-side-kits',
  't-torturers',
  't-up',
  'tabajara-clan',
  'taboo',
  'tac-titans',
  'taco',
  'tactical-8',
  'tactical-chaos',
  'tactical-titans',
  'tactical-trolls',
  'taegeuk',
  'tag',
  'tahmeow',
  'tainted-minds',
  'taipancsgo',
  'tajikistanseals',
  'taka',
  'take-aim',
  'take-flyte-a',
  'take-flyte-eu',
  'take-flyte',
  'takeflyte',
  'taking-it-deep',
  'talanta',
  'talented',
  'tamu-cs2',
  'tandoor',
  'tandourians',
  'tarczynski-protein',
  'taste-of-turkey',
  'taubate-esports',
  'tavern-brawlers',
  'tax-evaders',
  'taxidermists',
  'tba-benelux',
  'tba-ecf',
  'tbp',
  'tcm-gaming',
  'tdk',
  'tea-party',
  'team-3d',
  'team-7am-na',
  'team-aaa',
  'team-acer',
  'team-adsfk',
  'team-aether',
  'team-agg',
  'team-alexa',
  'team-alientech',
  'team-alientech',
  'team-amplus',
  'team-ancient',
  'team-ano',
  'team-arrow',
  'team-artistic',
  'team-ascend',
  'team-asd',
  'team-aunkere',
  'team-auspex',
  'team-avenge',
  'team-aztec',
  'team-babinkos',
  'team-backpack',
  'team-bald',
  'team-blackout',
  'team-brute',
  'team-catch-gamer',
  'team-coast',
  'team-comcast',
  'team-coop',
  'team-coph9k',
  'team-crazycoco',
  'team-cursive',
  'team-dainyko',
  'team-darkstuff',
  'team-deathgrip',
  'team-denied',
  'team-descend',
  'team-dignitas-female',
  'team-dignitas',
  'team-disrupt',
  'team-diversity',
  'team-divinity',
  'team-dna',
  'team-dwg',
  'team-dyloo',
  'team-dynamic',
  'team-eastpak',
  'team-ebettle',
  'team-eclipse',
  'team-elixir',
  'team-elusive',
  'team-empire',
  'team-emprox',
  'team-endpoint',
  'team-envy',
  'team-envyus',
  'team-esky',
  'team-eu4ia',
  'team-evelone192',
  'team-exceed',
  'team-exile5',
  'team-exploited',
  'team-extensive!',
  'team-factor',
  'team-fantasy',
  'team-fbeast',
  'team-fish',
  'team-flow',
  'team-forge',
  'team-fragster',
  'team-gamerdesk',
  'team-gamerlegion',
  'team-gaminate',
  'team-ganlalegion',
  'team-gdt',
  'team-gelo',
  'team-godeto',
  'team-gogeto',
  'team-gravitex',
  'team-hans',
  'team-heretics',
  'team-hyper',
  'team-i2k',
  'team-ibuypower',
  'team-immunity',
  'team-imperio-multimedia',
  'team-infernum',
  'team-infused',
  'team-innova',
  'team-instinct',
  'team-invictum',
  'team-ivory',
  'team-k-a-r-m-a',
  'team-ka6anbl',
  'team-kinguin',
  'team-kylin',
  'team-lampa',
  'team-ldlc',
  'team-ldlc',
  'team-ldlccom',
  'team-leisure',
  'team-lemon',
  'team-leveling',
  'team-lfrit',
  'team-lioncast',
  'team-liquid',
  'team-lowki',
  'team-lrp-poland',
  'team-lynx',
  'team-lyost',
  'team-m33',
  'team-maple',
  'team-max',
  'team-meliora',
  'team-menace',
  'team-method',
  'team-mischievous',
  'team-monarchs',
  'team-moon',
  'team-mouse',
  'team-mutiny',
  'team-mythic',
  'team-no-name',
  'team-noir',
  'team-nxl',
  'team-odyssey',
  'team-one',
  'team-orbit',
  'team-owl',
  'team-peanuts',
  'team-phenomenon',
  'team-phoenix',
  'team-phys',
  'team-plan-b',
  'team-preparation',
  'team-probl8m',
  'team-property',
  'team-prospects',
  'team-purity',
  'team-quazar',
  'team-quest',
  'team-r4n',
  'team-reapers',
  'team-rebound',
  'team-refuse',
  'team-retrowave',
  'team-revengers',
  'team-rn',
  'team-roccat',
  'team-rock',
  'team-royals',
  'team-s2pira',
  'team-sampi',
  'team-schwanek',
  'team-secret',
  'team-seeyou',
  'team-serenity',
  'team-server-forge',
  'team-shift',
  'team-shutdown',
  'team-sigma',
  'team-silver-mid',
  'team-singularity',
  'team-skillset',
  'team-skyfire',
  'team-skyline',
  'team-smoked',
  'team-solid',
  'team-solomid',
  'team-spirit',
  'team-storm8',
  'team-sufarex',
  'team-swins',
  'team-systorm',
  'team-team-name',
  'team-trigger-point',
  'team-trucknutz',
  'team-ubitum',
  'team-unique',
  'team-unity',
  'team-uo',
  'team-upsetti',
  'team-valipala',
  'team-venture',
  'team-verboten',
  'team-vertex',
  'team-vintage',
  'team-vitalerror',
  'team-vitality',
  'team-webone',
  'team-wheelchair',
  'team-wild-fire',
  'team-wild',
  'team-winfakt',
  'team-wingman',
  'team-wxm',
  'team-wydo',
  'team-x',
  'team-xdm',
  'team-xenex',
  'team-yetti',
  'team-yp',
  'team-zevs',
  'team',
  'team1',
  'team123',
  'team30plus',
  'team7am',
  'teamchez',
  'teamfathom',
  'teamflippers',
  'teamhydegg',
  'teamington',
  'teamisland256',
  'teamknaek',
  'teamkr-esport-club',
  'teamkr',
  'teamkwak',
  'teammischievous',
  'teamnicetry',
  'teamoff',
  'teamone',
  'teamorangegaming',
  'teamorkzsebesgoblin',
  'teamraised',
  'teamworkers',
  'teb-esport-pro',
  'tecfive',
  'tegoedvoornaam',
  'teiko-high-lfo',
  'teiko',
  'telos',
  'temp',
  'temperate',
  'tempest-gaming',
  'tempest',
  'temple-of-swing',
  'tempo-gaming',
  'tempo-storm',
  'tempos',
  'tempr',
  'tenerife-titans',
  'tension',
  'tentoesdown',
  'tera',
  'terra-avalon',
  'terraesportsb',
  'terraesportsp',
  'terror-otrodya',
  'terzy',
  'testdrive',
  'teveel-vlaams',
  'texas-orange',
  'tf-talents',
  'tgd',
  'tgj-esports',
  'tgj',
  'th3-reapers',
  'thats-my-friend',
  'the-027',
  'the-agency-clan',
  'the-animals-',
  'the-art-of',
  'the-asylum',
  'the-babes',
  'the-bardolphs',
  'the-big-dawgs',
  'the-black-company',
  'the-boats',
  'the-bomb-squad',
  'the-bombhogs',
  'the-borderless',
  'the-boys',
  'the-branded',
  'the-burgers',
  'the-bus-crew',
  'the-cavity-crew',
  'the-chosen-few',
  'the-chozen-ones',
  'the-cuddlers',
  'the-dawn-of-scrumtavious',
  'the-demo-review',
  'the-dice',
  'the-dominion',
  'the-equalizer',
  'the-fellas',
  'the-forge',
  'the-foundation',
  'the-gate',
  'the-gatekeepers',
  'the-gentlemen',
  'the-glecs',
  'the-goon-lagoon',
  'the-goose-house',
  'the-gu-krew',
  'the-guys',
  'the-hat-men',
  'the-homies',
  'the-hood-heroes',
  'the-huns',
  'the-imperial',
  'the-incas',
  'the-jizz-brozz',
  'the-kamni',
  'the-kittens',
  'the-last-resort',
  'the-le-bobix',
  'the-leftovers',
  'the-lycans',
  'the-main-f',
  'the-mansion',
  'the-matti-show',
  'the-milk-boyz',
  'the-milkmen',
  'the-mixlegends',
  'the-mongolz-academy',
  'the-mongolz',
  'the-oasis',
  'the-one',
  'the-overturners',
  'the-peons',
  'the-plague',
  'the-pokemons',
  'the-prodigies',
  'the-pug-jug',
  'the-qube',
  'the-ranch',
  'the-roaches',
  'the-russia',
  'the-saints',
  'the-secret-club',
  'the-shield',
  'the-silly-squirrels',
  'the-skins',
  'the-ssc',
  'the-suga-show',
  'the-suspect',
  'the-thatchers',
  'the-third-eye',
  'the-tinderellas-10',
  'the-trongolz',
  'the-unction',
  'the-union',
  'the-van-dyke-browns',
  'the-vynz',
  'the-wanderers',
  'the-witchers',
  'the',
  'theboysareback',
  'thedegenertates',
  'thedice',
  'thednc',
  'thedodgefathers',
  'thefree',
  'thegns',
  'thegoodmen',
  'thehobbyists',
  'thelastdragons',
  'thelastresort',
  'thelizards',
  'them3n',
  'themoneyteam',
  'themongolz',
  'themonolith',
  'themotherlovers',
  'theory',
  'theotherguys',
  'thesenseiladews',
  'thespectruminus',
  'thespensers',
  'thicc-nut',
  'thinkers',
  'third-eye',
  'third-impact',
  'thirdsite',
  'thrash',
  'threats',
  'three11',
  'throat-goats',
  'thronzor-esport',
  'thunder-birds',
  'thunder-downunder',
  'thunder-logic',
  'thunderbolts',
  'thunderflash',
  'thunderflashtm',
  'tiger',
  'tiim',
  'timacet4',
  'timbermen',
  'time-waves',
  'timeline-cs',
  'tindergold',
  'tinikta-esports',
  'tiramisu',
  'titan',
  'titanium-balls',
  'titans-esports',
  'tlastresistance',
  'tmvg-rctic',
  'tmvg',
  'tnc-esports',
  'tnc-pro-team',
  'tnc',
  'tnl',
  'tnt',
  'to-de-gurgel',
  'to-the-major',
  'to-the-moon',
  'toadsuckies',
  'toby-pyllistys',
  'tojiphysique',
  'token-gaming',
  'tokengmgwhite',
  'tokyo',
  'tokyomanji',
  'tokyosavage',
  'tone-setters',
  'tonka-truck',
  'tonyanderthals',
  'toofarcs',
  'toomanysomalis',
  'toomuchvideogames',
  'top-black',
  'top-g',
  'top-model',
  'top-one-percent',
  'top-white',
  'topflare',
  'toplovers',
  'toptab-club',
  'toptab',
  'torpedo',
  'torqued',
  'tortuga',
  'total-esport',
  'totale-pro',
  'totalepro',
  'totalne-gituwy',
  'totem',
  'tothebitterend',
  'totsugeki',
  'touch-down',
  'touch-point',
  'touch-the-crown',
  'trackpadgaming',
  'tracksuitgaming',
  'tractors',
  'trafficpills-esports',
  'trafficpills',
  'tragically-bad',
  'training-wheels',
  'trainwrecks',
  'traker-esport',
  'tralaleotralala',
  'tranquillum',
  'transcendence',
  'trash-island',
  'trasko',
  'tredjefemman',
  'trenblone-users',
  'trench-foot',
  'triangletraders',
  'tribal-chiefs',
  'tricked-esport',
  'tricked',
  'tricksters',
  'trident-clan',
  'trident-esports',
  'trident',
  'trifecta-gaming',
  'triggers-down',
  'triple5coped',
  'triton',
  'triumph',
  'troca-troca',
  'trollingatbest',
  'tropa-do-bizinhorx',
  'tropa-suprema',
  'troya-legion',
  'truck-drivers',
  'true-ambition',
  'true-rippers',
  'true-thunder',
  'trumptrain',
  'truppen',
  'trust',
  'try-again-19',
  'tryaska',
  'tryhearts',
  'trypants',
  'trz',
  'tsaislemec',
  'tsars-triumph',
  'tsegtaslal',
  'tsetsegchid',
  'tsg',
  'tsingtao',
  'tsl-black',
  'tsl-white',
  'tsm',
  'tsunami-academy',
  'tsunami-esports',
  'tsunami-rising',
  'tsunami-sirens',
  'tsunami',
  'tt-willhaben',
  'tugaclan',
  'tugboat',
  'tuktuk-peek',
  'tuna-can-clan',
  'tuna-can-girth',
  'tundra',
  'tunneldwellers',
  'turbo-przyglupy',
  'turbo4funhavers',
  'turkey5',
  'turkey7',
  'turkishbhouse',
  'turma-do-pagode',
  'turow-zgorzelec',
  'turritos',
  'turtispeek',
  'turtles-clan',
  'tuskem',
  'tuste-chopaki',
  'tutel',
  'tuvalu-embassy',
  'tweam-gamers',
  'twentyr-gaming',
  'twice',
  'twilight-thunderclap',
  'twisted-minds',
  'twistzz-lovers',
  'twodads',
  'twointheshirt',
  'txt-gaming',
  'tycoon',
  'tyler-blows',
  'tyloo',
  'type-shi',
  'tzatziki-empire',
  'u-cluj-esports',
  'ubc-vertigo',
  'ubiquiti',
  'ubiteam',
  'uc',
  'ucam-esports-club',
  'uchoa',
  'ucsr',
  'udem-sales-babz',
  'udp-romania',
  'udp',
  'ugk',
  'uhka-esports',
  'uk-ripper',
  'uk',
  'ukcs',
  'ukenergycrisis',
  'ul-red',
  'ultimatedarklordwizardz',
  'ultimax-gaming',
  'ultrawhite',
  'umx',
  'uncles',
  'undefined',
  'under-score',
  'under-the-radar',
  'underground-cs',
  'underground',
  'underworld-knights',
  'underworld',
  'uneven-academy',
  'uneven',
  'unfilteredchaos',
  'ungent',
  'ungentium',
  'unicorns-of-love',
  'union',
  'union88',
  'unique-team',
  'unique',
  'uniquestars',
  'united-kingdom',
  'united-nutsacks',
  'united5',
  'unitedstatesarmy-esports',
  'unity-ac',
  'unity-esports',
  'unity',
  'unitywave',
  'universal-soldiers',
  'university-of-cincinnati',
  'uniway',
  'unjustified-ac',
  'unjustified-fe',
  'unjustified',
  'unknown',
  'unknowns',
  'unkreativ-lfo',
  'unlucky-boys',
  'unluckyday',
  'unluk000',
  'unnamed-project',
  'uno-mille',
  'unoplanerinious',
  'unplanned',
  'unravel',
  'unsettledresent',
  'unsigned',
  'unskilled',
  'unstoppaballs',
  'untitled',
  'unwillordinary',
  'uofdenver',
  'uoft-varsity',
  'up1',
  'updraft',
  'upgrade',
  'ur',
  'urnan-clan',
  'ursa',
  'usa-synapse',
  'ussr-team',
  'ut-austin',
  'utm-esports',
  'utopia-',
  'utopia-clan',
  'uv1',
  'uvu-esports',
  'uwuza100sm',
  'ux-gaming',
  'uyu',
  'uzumakii',
  'v-fortis-fe',
  'v-ster-s',
  'v0rtex',
  'v12already',
  'v1dar-gaming',
  'v1dar',
  'vac-banned',
  'vacdads',
  'vae-victis',
  'vael',
  'vagrants',
  'vaiafatima',
  'vaksa',
  'valerion-esports',
  'valhalla-vikings',
  'valhalla-vision',
  'valhalla',
  'valianceandco',
  'validity-x',
  'valkence',
  'valkyria',
  'valkyrie',
  'valla',
  'vallea',
  'valorant-playerz',
  'valorant',
  'valorix',
  'valors',
  'vamos',
  'vanaskap',
  'vandals',
  'vandulken',
  'vanir',
  'vanirgg',
  'vanirquick',
  'vanta',
  'vantage-academy',
  'vantage',
  'vantageesc',
  'variance-gaming',
  'vasco',
  'vaseline-worms',
  'vasterasesport',
  'vasytystactic',
  'vatican-city',
  'vault',
  'vcgo',
  'vega-e-sport',
  'vega-gaming',
  'vega-squadron',
  'vega96',
  'vellamo',
  'veloce-esports',
  'velox-argentina',
  'velox-esports',
  'velox',
  'velox',
  'veloxgg',
  'veloz',
  'venary-talent',
  'vence',
  'veni-vidi-vici',
  'venom-esports',
  'venom',
  'verboten',
  'verdant',
  'verdict',
  'vertex-esc',
  'vertex',
  'verum',
  'verybigdoogoos',
  'verygames',
  'veryseriousgmrz',
  'veto',
  'vex-dragons',
  'vex',
  'vexa',
  'vexaile',
  'vexar',
  'vexed-gaming',
  'vexed',
  'vexed',
  'vexo-purple',
  'vexx-gaming',
  'vg',
  'vg',
  'vgflashgaming',
  'vgtu-esports',
  'vibe-check',
  'vibe-esports',
  'vibe',
  'vibes-n-vyvanse',
  'vice-versa',
  'vici-gaming',
  'vici',
  'vicious-kitties',
  'victores-sumus',
  'victorum',
  'victory-royale',
  'victory-zigzag',
  'victus',
  'vidstodu',
  'viina-ga',
  'viking',
  'vikings',
  'vilay-esport',
  'vilay',
  'villainarc',
  'villainous',
  'villains',
  'vilok-kapustbi',
  'vination-esports-e',
  'vincam-elite',
  'vindicta',
  'vinkelparty',
  'vintage',
  'viperio',
  'viperioacademy',
  'viral-eclub',
  'vireo-pro',
  'vireo',
  'vireopro',
  'virosity',
  'virtal-limits',
  'virtual-genesis',
  'virtual-grounds',
  'virtualcasino',
  'virtualgangstas',
  'virtue-gaming',
  'virtuoso-squad',
  'virtus-pro',
  'virtus',
  'visio',
  'vision-gaming',
  'vision',
  'visionary',
  'visions-mason-chasen',
  'visu-gaming',
  'visu',
  'vitalem-aerem',
  'vitality',
  'vitaplur-gum',
  'vitaplur-plasma',
  'vitone',
  'vitriol',
  'viu-gaming',
  'viva-algeria',
  'viva-la-viv',
  'vivid-utd',
  'vivo-keyd',
  'vivo',
  'vixit',
  'vizard',
  'vizeo',
  'vizora-esports',
  'vizora',
  'vkbest',
  'vlone-wolves',
  'vlonely',
  'vnd',
  'vnt',
  'voca',
  'voddysodas',
  'voice-enable-0',
  'voicelessesport',
  'void-alune',
  'void-gaming',
  'void-sentinels',
  'void',
  'voidic',
  'volderods',
  'volgare',
  'vollaufnase',
  'volt',
  'voltage-essm',
  'voracity',
  'vorn',
  'vorpal-swords',
  'vortex-vanguard',
  'vortex',
  'vox-victorum',
  'voyvoda',
  'vp-angels',
  'vp-future',
  'vp-prodigy',
  'vp',
  'vpprodigy',
  'vrotix-junior',
  'vslash',
  'vtm-blaze',
  'vvide-swingers',
  'vws-gaming',
  'vybn',
  'w-men-ai-nanren',
  'w0wclan',
  'w2c',
  'w4stedt4l3nts',
  'w7m-esports-ac',
  'w7m-esports',
  'w7m-fe',
  'w7m-gaming',
  'w7m',
  'w81',
  'wabbit2',
  'wafaw',
  'wah',
  'waitforit',
  'waitfortag',
  'wake-n-bake',
  'walczaki',
  'waldelocker',
  'walk-the-talk',
  'walkthemdown',
  'wallahi',
  'wallahi123',
  'waltuh',
  'wambit',
  'wanted-goons',
  'wap',
  'wardens',
  'warlegend',
  'warmaker',
  'warriorpath',
  'warriors-international',
  'warriors',
  'warstyle',
  'wartex-eu',
  'wartex',
  'warthox-esport',
  'warthox',
  'washdup23yrolds',
  'washed-gamers',
  'washed-grandpas',
  'washed-squad',
  'washedbutdirty',
  'washington',
  'wasted-potential',
  'wasted-talents',
  'wastedpotent1al',
  'wastedpotential',
  'wat-da-dog-doin',
  'watch-out',
  'waterboarding-fan-club',
  'waterboys',
  'waterdogs',
  'watermelon',
  'wave-esports',
  'wave',
  'wavey',
  'waxbyz',
  'wayward-sons',
  'wazabi',
  'wbt-academy',
  'wbt',
  'wc-shotgunners',
  'we-almost-had-it',
  'we-are-silly',
  'we-back',
  'we-dem-boyz',
  'we-got-game',
  'we-have-a-felon',
  'we-play-naked',
  'wealth-reduction',
  'wearebums',
  'webangin',
  'webspell-gaming',
  'webspell',
  'websterz',
  'weclear',
  'weeabooboos',
  'weeknd-warriors',
  'wegaanvoorgoud',
  'wenkas',
  'were-so-back',
  'werty-ac-aqua',
  'werty-ac-blood',
  'werty-ac-fire',
  'werty-ac-jade',
  'werunthisplace',
  'wesports',
  'west-coasters',
  'western-wolves',
  'wg-academy',
  'wg-bandits',
  'wg-outlaws',
  'whalersondamoon',
  'what-doink',
  'what-the-helly',
  'whatever',
  'whats-it-called',
  'when-deez-squad',
  'whiffvagninn',
  'white-flames',
  'white-iverson',
  'white-rabbit-am',
  'white-rabbit',
  'whitebeard',
  'whitebird',
  'whiteclowns',
  'whng-team',
  'who-cares',
  'wholders',
  'whykick-team',
  'whynot',
  'whysoserious',
  'wicked-esports',
  'wicked',
  'wide-open',
  'wide-swinging-wizards',
  'wideswingers',
  'wiff-check',
  'wiggle-peeks',
  'wild-panthers',
  'wild-wolverines-reborn',
  'wild',
  'wildcard-academy',
  'wildcard',
  'wildcats',
  'wimpy-chimps',
  'wind-and-rain',
  'windigo-gaming',
  'windigo',
  'windigo',
  'windingo',
  'windingogg',
  'wingers',
  'wings-gaming',
  'wings-up',
  'winland',
  'winnercompany',
  'winners',
  'winside',
  'winstrike-team',
  'winstrike',
  'winterfox',
  'wishfulwarriors',
  'wisla-krakow',
  'wisp',
  'without-a-roof',
  'wizard',
  'wizards-e-sports-club',
  'wizards',
  'wkb',
  'wklemmt',
  'wlgaming',
  'wmdwm',
  'wnt',
  'woaromdatten',
  'wobbegong',
  'wobuzhidao',
  'woe-from-wit',
  'woke-mob',
  'wolfgang',
  'wolfpack',
  'wololos',
  'wolsung',
  'wolves',
  'wooting-peek',
  'wopa-esport',
  'wopa',
  'working-men',
  'world-reavers',
  'worm-clan',
  'worst-players',
  'wortex',
  'wot-esports',
  'wozzlerus',
  'wr3k',
  'ws-esports',
  'wtsickness',
  'wu-tang-mix',
  'wu-tang-mixx',
  'wuhuarou',
  'ww',
  'wwaves',
  'wwplayers',
  'www-wewillwin',
  'www',
  'wydo',
  'wygers-argentina',
  'wygers',
  'wysix',
  'wzm-de-father',
  'x-city-m2',
  'x-city',
  'x-gamer',
  'x-gaming',
  'x-kom-team',
  'x-squad',
  'x-teamdach',
  'x',
  'x13',
  'x5',
  'x6tence-galaxy',
  'x6tence',
  'x7-academy',
  'x7-team',
  'x7',
  'xapso',
  'xastris',
  'xcity',
  'xdasdf',
  'xdm',
  'xelectro-esport',
  'xenex',
  'xgame',
  'xgod-arena',
  'xi-antaichanggui',
  'xi-esport',
  'xi',
  'xidil-strike',
  'xil3-academy',
  'xim-aimers',
  'xing-xing',
  'xist',
  'xiyarmix',
  'xmplfy-black',
  'xmplfy',
  'xp-academy',
  'xp-ankh',
  'xp-ansuz',
  'xp-project',
  'xpc-gaming',
  'xperion-nxt',
  'xplicit',
  'xset',
  'xtinct',
  'xtream-e-sport',
  'xtrem-skilled',
  'xuneas',
  'xxx-',
  'xy-esports',
  'xy',
  'xyston',
  'y-create',
  'yakogo-didkya',
  'yalla',
  'yap-city',
  'yasai',
  'yawara-e-sports',
  'yawara',
  'ycreate',
  'yeah-gaming',
  'yeah',
  'yellow-dragons',
  'yengi',
  'yenicherry',
  'yenkee-academy',
  'yenkee',
  'yeyo',
  'yhtr',
  'yhubepcam',
  'yinxing-gaming',
  'yippeee',
  'yippie',
  'yk-gaming',
  'yk',
  'ymca-esports',
  'ynd',
  'yng-sharks',
  'yngstxrs',
  'ynity',
  'ynt',
  'yocrew',
  'yod-esports',
  'yod',
  'yogaball-frags',
  'yomi-6-brigade',
  'yondaleathletic',
  'yooooooo',
  'youfeelmee',
  'young-glorians',
  'young-gods',
  'young-ninjas',
  'young-rodents',
  'young-tigeres',
  'youngkings',
  'younglings',
  'youngstars',
  'yourboss',
  'youreanus-llc',
  'youseehim',
  'youwork2ndshift',
  'ys-talents',
  'ystads-if',
  'yungrichhndsome',
  'yungrichniceguy',
  'yungsters',
  'yuyiette',
  'yxg-white',
  'z-nation',
  'z7',
  'zagreb-360-gaming',
  'zark',
  'zashkvar',
  'zawisza-esports',
  'zbk',
  'ze-pug-godz',
  'ze-republic',
  'zeal22',
  'zealous',
  'zearless',
  'zelka-reborn',
  'zelka-revival',
  'zen-garden',
  'zenano',
  'zengaming',
  'zenith',
  'zenithfps',
  'zennit',
  'zennox-academy',
  'zennox-gaming',
  'zennox',
  'zenq-ninjas',
  'zerance',
  'zero-bomb',
  'zero-gravity',
  'zero-hero',
  'zero-latency',
  'zero-marksmen',
  'zero-tenacity',
  'zerodivinity1',
  'zerofailure-na',
  'zerooneclan-hvc',
  'zerovariant',
  'zerozone',
  'zespol-bobra',
  'zespolr',
  'zeta',
  'zevs',
  'zigma',
  'znation',
  'zobrux',
  'zodiac-5',
  'zolwodtylu',
  'zomblers',
  'zomblersacademy',
  'zone-of-victory',
  'zonked-academy',
  'zonked-e-sports',
  'zonked-main',
  'zoomnboom',
  'zooweemama',
  'zorka',
  'zotix',
  'zrrttgaming',
  'ztraf',
  'zynthusiasts',
];
